import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';
import './ListeEtudiants.css';
import {
  STRUCTURE_FORMATION,
  FILIERE_BY_MODE,
  getFilieresParMode,
  getSpecialitesDisponibles,
  getOptionsDisponibles,
  getSpecialites2Disponibles,
  getOptions2Disponibles,
  getCycleParNiveau,
  getTypeFormation,
  getSpecialitesIngenieur,
  getOptionsIngenieur,
  isTypeFormationIngenieur,
  handleFormationChange,
  genererAnneeScolaireActuelle,
  validerAnneeScolaire,
  validerFormationComplete,
  genererCodeEtudiantMisAJour,
  isManualFiliere,
  getNiveauxDisponibles,
  LIEUX_FORMATION,
  SOURCES_INSCRIPTION,
  pickBestCours,
  autoAssignCours
} from '../components/formationUtils';

import {
  User,
  CheckCircle,
  XCircle,
  Award, Shield, Clock, Plus,
  Phone,
  LogOut,
  Eye,
  EyeOff,
  Edit,
  BookOpen,
  Calendar,
  Cake,
  RotateCcw,
  X,
  Trash2,
  UserCheck,
  IdCard,
  MapPin,
  GraduationCap,
  CreditCard,
  FileText
} from "lucide-react";
const PAYS_LIST = [
  'Afghanistan', 'Afrique du Sud', 'Albanie', 'Algérie', 'Allemagne', 'Andorre', 'Angola', 'Antigua-et-Barbuda',
  'Arabie Saoudite', 'Argentine', 'Arménie', 'Australie', 'Autriche', 'Azerbaïdjan', 'Bahamas', 'Bahreïn',
  'Bangladesh', 'Barbade', 'Belgique', 'Belize', 'Bénin', 'Bhoutan', 'Biélorussie', 'Birmanie', 'Bolivie',
  'Bosnie-Herzégovine', 'Botswana', 'Brésil', 'Brunei', 'Bulgarie', 'Burkina Faso', 'Burundi', 'Cambodge',
  'Cameroun', 'Canada', 'Cap-Vert', 'Chili', 'Chine', 'Chypre', 'Colombie', 'Comores', 'Congo', 'Corée du Sud',
  'Costa Rica', 'Côte d’Ivoire', 'Croatie', 'Cuba', 'Danemark', 'Djibouti', 'Dominique', 'Égypte', 'El Salvador',
  'Émirats arabes unis', 'Équateur', 'Érythrée', 'Espagne', 'Estonie', 'Eswatini', 'États-Unis', 'Éthiopie',
  'Fidji', 'Finlande', 'France', 'Gabon', 'Gambie', 'Géorgie', 'Ghana', 'Grèce', 'Grenade', 'Guatemala',
  'Guinée', 'Guinée équatoriale', 'Guinée-Bissau', 'Guyana', 'Haïti', 'Honduras', 'Hongrie', 'Îles Cook',
  'Îles Marshall', 'Îles Salomon', 'Inde', 'Indonésie', 'Irak', 'Iran', 'Irlande', 'Islande', 'Israël', 'Italie',
  'Jamaïque', 'Japon', 'Jordanie', 'Kazakhstan', 'Kenya', 'Kirghizistan', 'Kiribati', 'Koweït', 'Laos', 'Lesotho',
  'Lettonie', 'Liban', 'Libéria', 'Libye', 'Liechtenstein', 'Lituanie', 'Luxembourg', 'Macédoine', 'Madagascar',
  'Malaisie', 'Malawi', 'Maldives', 'Mali', 'Malte', 'Maroc', 'Maurice', 'Mauritanie', 'Mexique', 'Micronésie',
  'Moldavie', 'Monaco', 'Mongolie', 'Monténégro', 'Mozambique', 'Namibie', 'Nauru', 'Népal', 'Nicaragua',
  'Niger', 'Nigéria', 'Norvège', 'Nouvelle-Zélande', 'Oman', 'Ouganda', 'Ouzbékistan', 'Pakistan', 'Palaos',
  'Palestine', 'Panama', 'Papouasie-Nouvelle-Guinée', 'Paraguay', 'Pays-Bas', 'Pérou', 'Philippines', 'Pologne',
  'Portugal', 'Qatar', 'République démocratique du Congo', 'Roumanie', 'Royaume-Uni', 'Russie', 'Rwanda', 'Saint-Kitts-et-Nevis', 'Saint-Marin',
  'Saint-Vincent-et-les-Grenadines', 'Sainte-Lucie', 'Samoa', 'Sao Tomé-et-Principe', 'Sénégal', 'Serbie',
  'Seychelles', 'Sierra Leone', 'Singapour', 'Slovaquie', 'Slovénie', 'Somalie', 'Soudan', 'Soudan du Sud',
  'Sri Lanka', 'Suède', 'Suisse', 'Suriname', 'Syrie', 'Tadjikistan', 'Tanzanie', 'Tchad', 'Thaïlande',
  'Timor oriental', 'Togo', 'Tonga', 'Trinité-et-Tobago', 'Tunisie', 'Turkménistan', 'Turquie', 'Tuvalu',
  'Ukraine', 'Uruguay', 'Vanuatu', 'Vatican', 'Venezuela', 'Viêt Nam', 'Yémen', 'Zambie', 'Zimbabwe'
];

// ====== Utils auto-cours ======
const normalize = (s = "") =>
  s
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")  // accents ➜ simple
    .replace(/&/g, "et")
    .replace(/[^a-z0-9\s]/gi, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

const buildCoursCandidates = (f) => {
  const out = [];
  const n = Number(f.niveau || 0);
  const y = f.niveau ? `${f.niveau} Année` : "";

  if (!f.filiere) return out;

  if (f.filiere === "MASI") {
    if (n >= 1 && n <= 2) out.push(`MASI ${y}`);
    if ((n === 3 || n === 4) && f.specialite) out.push(`MASI ${f.specialite} ${y}`);
    if (n === 5) {
      if (f.specialite && f.option) out.push(`MASI ${f.specialite} ${f.option} ${y}`); // ✅ le plus précis
      if (f.option) out.push(`MASI ${f.option} ${y}`);
      if (f.specialite) out.push(`MASI ${f.specialite} ${y}`);
    }
  } else if (f.filiere === "IRM") {
    if (n >= 1 && n <= 2) out.push(`IRM ${y}`);
    if ((n === 3 || n === 4) && f.specialite) out.push(`IRM ${f.specialite} ${y}`);
    if (n === 5) {
      if (f.specialite && f.option) out.push(`IRM ${f.specialite} ${f.option} ${y}`); // ✅ le plus précis
      if (f.option) out.push(`IRM ${f.option} ${y}`);
      if (f.specialite) out.push(`IRM ${f.specialite} ${y}`);
    }
  } else if (f.filiere === "CYCLE_INGENIEUR") {
    if (n >= 1 && n <= 2) out.push(`Classes Préparatoires ${y}`);
    if (n >= 3) {
      if (n === 5 && f.optionIngenieur) out.push(`${f.optionIngenieur} 5 Année`);
      if (f.specialiteIngenieur) out.push(`${f.specialiteIngenieur} ${y}`);
    }
  } else if (f.filiere === "LICENCE_PRO") {
    if (f.specialiteLicencePro) {
      let s = `Licence Pro ${f.specialiteLicencePro}`;
      if (f.optionLicencePro) s += ` - ${f.optionLicencePro}`;
      out.push(s);
    }
  } else if (f.filiere === "MASTER_PRO") {
    if (f.specialiteMasterPro) {
      let s = `Master Pro ${f.specialiteMasterPro}`;
      if (f.optionMasterPro) s += ` - ${f.optionMasterPro}`;
      out.push(s);
    }
  }

  return out.filter(Boolean);
};

// pickBestCours et autoAssignCours sont importés depuis ../components/formationUtils


// Composant FormationSelector adapté au nouveau modèle backend
const FormationSelector = ({ form, onChange, prefix = '' }) => {
  const formationData = form.filiere ? STRUCTURE_FORMATION[form.filiere] : null;
  const isIngenieur = form.filiere === 'CYCLE_INGENIEUR';
  const hasNiveauFixe = formationData && !formationData.niveauxManuels;
  const allowedFilieres = getFilieresParMode(form.niveauFormation || '');

  // Pour les formations avec niveau auto-assigné, afficher le niveau fixe
  const niveauAffiche = hasNiveauFixe ? formationData.niveauFixe : form.niveau;

  useEffect(() => {
    if (hasNiveauFixe && formationData?.niveauFixe) {
      const attendu = String(formationData.niveauFixe);
      if (String(form.niveau) !== attendu) {
        onChange('niveau', attendu);
      }
    }
  }, [hasNiveauFixe, formationData, form.niveau]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isIngenieur && form.niveau) {
      const attendu = getCycleParNiveau(form.niveau);
      if (form.cycle !== attendu) {
        onChange('cycle', attendu);
      }
    }
  }, [isIngenieur, form.niveau, form.cycle]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="formation-selector">
      <div className="form-row">
        <div className="form-group">
          <label>Filière *</label>
          <select
            name="filiere"
            value={form.filiere}
            onChange={(e) => onChange('filiere', e.target.value)}
            required
            disabled={!form.niveauFormation} // ما نسمحش بالاختيار قبل ما يختار المود
          >
            {!form.niveauFormation ? (
              <option value="">Choisissez d'abord FI / TA / Executive</option>
            ) : (
              <>
                <option value="">Sélectionner le type de formation...</option>
                {allowedFilieres.map((key) => (
                  <option key={key} value={key}>
                    {STRUCTURE_FORMATION[key]?.nom || key}
                  </option>
                ))}
              </>
            )}
          </select>
          {!form.niveauFormation && (
            <small style={{ color: '#666' }}>Veuillez choisir le mode (FI / TA / Executive) d'abord</small>
          )}
        </div>

        {/* Niveau - manuel pour certaines formations, auto-assigné pour d'autres */}
        <div className="form-group">
          <label>
            Niveau
            {hasNiveauFixe && (
              <span className="auto-assigned"> (Auto-assigné)</span>
            )}
          </label>
          {hasNiveauFixe ? (
            <input
              type="text"
              value={`Niveau ${niveauAffiche}`}
              disabled
              style={{ backgroundColor: '#f0f0f0', color: '#666' }}
            />
          ) : (
            <select
              name="niveau"
              value={form.niveau || ''}
              onChange={(e) => onChange('niveau', e.target.value)}
              required={form.filiere && !hasNiveauFixe}
            >
              <option value="">Sélectionner le niveau...</option>
              {getNiveauxDisponibles(form.filiere).map((n) => (
                <option key={n} value={String(n)}>
                  {n === 1 ? '1ère année' : `${n}ème année`}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>

      {/* Cycle pour École d'Ingénieur */}
      {isIngenieur && form.niveau && (
        <div className="form-group">
          <label>Cycle *</label>
          <input
            type="text"
            value={form.cycle || getCycleParNiveau(form.niveau)}
            disabled
            style={{ backgroundColor: '#f0f0f0', color: '#666' }}
          />
          <small style={{ color: '#666', fontSize: '12px' }}>
            Le cycle est déterminé automatiquement selon le niveau
          </small>
        </div>
      )}

      {/* Spécialité d'Ingénieur */}
      {isIngenieur && form.niveau >= 3 && (
        <div className="form-group">
          <label>Spécialité d'Ingénieur *</label>
          <select
            name="specialiteIngenieur"
            value={form.specialiteIngenieur || ''}
            onChange={(e) => onChange('specialiteIngenieur', e.target.value)}
            required
          >
            <option value="">Sélectionner la spécialité...</option>
            {formationData.cycles['Cycle Ingénieur'].specialites.map((spec) => (
              <option key={spec} value={spec}>{spec}</option>
            ))}
          </select>
        </div>
      )}

      {/* Option d'Ingénieur */}
      {isIngenieur && form.niveau == 5 && form.specialiteIngenieur && (
        <div className="form-group">
          <label>Option d'Ingénieur *</label>
          <select
            name="optionIngenieur"
            value={form.optionIngenieur || ''}
            onChange={(e) => onChange('optionIngenieur', e.target.value)}
            required
          >
            <option value="">Sélectionner l'option...</option>
            {formationData.cycles['Cycle Ingénieur'].options[form.specialiteIngenieur]?.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
      )}

      {/* Spécialité Licence Pro */}
      {form.filiere === 'LICENCE_PRO' && (
        <div className="form-group">
          <label>Spécialité Licence Pro *</label>
          <select
            name="specialiteLicencePro"
            value={form.specialiteLicencePro || ''}
            onChange={(e) => onChange('specialiteLicencePro', e.target.value)}
            required
          >
            <option value="">Sélectionner une spécialité...</option>
            {formationData.specialites.map((spec) => (
              <option key={spec} value={spec}>{spec}</option>
            ))}
          </select>
        </div>
      )}

      {/* Option Licence Pro */}
      {form.filiere === 'LICENCE_PRO' && form.specialiteLicencePro && formationData.options[form.specialiteLicencePro] && (
        <div className="form-group">
          <label>Option Licence Pro</label>
          <select
            name="optionLicencePro"
            value={form.optionLicencePro || ''}
            onChange={(e) => onChange('optionLicencePro', e.target.value)}
          >
            <option value="">Sélectionner une option...</option>
            {formationData.options[form.specialiteLicencePro].map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
      )}

      {/* Spécialité Master Pro */}
      {form.filiere === 'MASTER_PRO' && (
        <div className="form-group">
          <label>Spécialité Master Pro *</label>
          <select
            name="specialiteMasterPro"
            value={form.specialiteMasterPro || ''}
            onChange={(e) => onChange('specialiteMasterPro', e.target.value)}
            required
          >
            <option value="">Sélectionner une spécialité...</option>
            {formationData.specialites.map((spec) => (
              <option key={spec} value={spec}>{spec}</option>
            ))}
          </select>
        </div>
      )}

      {/* Option Master Pro */}
      {form.filiere === 'MASTER_PRO' && form.specialiteMasterPro && formationData.options[form.specialiteMasterPro] && (
        <div className="form-group">
          <label>Option Master Pro</label>
          <select
            name="optionMasterPro"
            value={form.optionMasterPro || ''}
            onChange={(e) => onChange('optionMasterPro', e.target.value)}
          >
            <option value="">Sélectionner une option...</option>
            {formationData.options[form.specialiteMasterPro].map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
      )}

      {/* Spécialité pour MASI/IRM/GENIE_CIVIL/MECATRONIQUE */}
      {isManualFiliere(form.filiere) && form.niveau >= 3 && (
        <div className="form-group">
          <label>Spécialité *</label>
          <select
            name="specialite"
            value={form.specialite || ''}
            onChange={(e) => onChange('specialite', e.target.value)}
            required
          >
            <option value="">Sélectionner la spécialité...</option>
            {getSpecialitesDisponibles(form.filiere, form.niveau).map((spec) => (
              <option key={spec} value={spec}>{spec}</option>
            ))}
          </select>
        </div>
      )}

      {/* Option pour MASI/IRM/GENIE_CIVIL/MECATRONIQUE */}
      {isManualFiliere(form.filiere) && form.niveau == 5 && form.specialite && getOptionsDisponibles(form.filiere, form.niveau, form.specialite).length > 0 && (
        <div className="form-group">
          <label>Option *</label>
          <select
            name="option"
            value={form.option || ''}
            onChange={(e) => onChange('option', e.target.value)}
            required
          >
            <option value="">Sélectionner l'option...</option>
            {getOptionsDisponibles(form.filiere, form.niveau, form.specialite).map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
      )}

      {/* Indicateur de parcours */}
      {form.filiere && (
        <div className="parcours-indicator">
          <h5>Parcours sélectionné :</h5>
          <div className="parcours-path">
            <span className="parcours-item filiere">
              {formationData?.nom || form.filiere}
            </span>
            {niveauAffiche && (
              <>
                <span className="parcours-arrow">→</span>
                <span className="parcours-item niveau">
                  Niveau {niveauAffiche}
                  {hasNiveauFixe && <small> (auto)</small>}
                </span>
              </>
            )}
            {form.cycle && (
              <>
                <span className="parcours-arrow">→</span>
                <span className="parcours-item cycle">{form.cycle}</span>
              </>
            )}
            {(form.specialiteIngenieur || form.specialiteLicencePro || form.specialiteMasterPro || form.specialite) && (
              <>
                <span className="parcours-arrow">→</span>
                <span className="parcours-item specialite">
                  {form.specialiteIngenieur || form.specialiteLicencePro || form.specialiteMasterPro || form.specialite}
                </span>
              </>
            )}
            {(form.optionIngenieur || form.optionLicencePro || form.optionMasterPro || form.option) && (
              <>
                <span className="parcours-arrow">→</span>
                <span className="parcours-item option">
                  {form.optionIngenieur || form.optionLicencePro || form.optionMasterPro || form.option}
                </span>
              </>
            )}
          </div>
        </div>
      )}

      {/* Double Compétence IT */}
      <div className="form-group" style={{ marginTop: '20px', padding: '12px 16px', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px', color: '#1e293b', marginBottom: 0 }}>
          <input
            type="checkbox"
            name="doubleCompetenceIT"
            checked={!!form.doubleCompetenceIT}
            onChange={(e) => onChange('doubleCompetenceIT', e.target.checked)}
            style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#2563eb' }}
          />
          <span>Double Compétence IT</span>
        </label>

        {form.doubleCompetenceIT && (
          <div className="double-competence-block" style={{ marginTop: '14px', paddingTop: '14px', borderTop: '1px dashed #94a3b8' }}>
            <h5 style={{ marginBottom: '12px', color: '#0f172a', fontSize: '13px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Deuxième Formation (Double Compétence)
            </h5>
            <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
              <div className="form-group">
                <label style={{ fontSize: '12px', fontWeight: '600' }}>Mode de formation 2</label>
                <select
                  name="niveauFormation2"
                  value={form.niveauFormation2 || ''}
                  onChange={(e) => onChange('niveauFormation2', e.target.value)}
                >
                  <option value="">Sélectionner le mode 2...</option>
                  <option value="FI">FI (Formation Initiale)</option>
                  <option value="TA">TA (Temps Alterné)</option>
                  <option value="Executive">Executive</option>
                  <option value="VAE">VAE</option>
                </select>
              </div>

              <div className="form-group">
                <label style={{ fontSize: '12px', fontWeight: '600' }}>Filière 2</label>
                <select
                  name="filiere2"
                  value={form.filiere2 || ''}
                  onChange={(e) => onChange('filiere2', e.target.value)}
                  disabled={!form.niveauFormation2}
                >
                  {!form.niveauFormation2 ? (
                    <option value="">Choisissez le mode 2 d'abord</option>
                  ) : (
                    <>
                      <option value="">Sélectionner la filière 2...</option>
                      {getFilieresParMode(form.niveauFormation2 || '').map((key) => (
                        <option key={key} value={key}>
                          {STRUCTURE_FORMATION[key]?.nom || key}
                        </option>
                      ))}
                    </>
                  )}
                </select>
              </div>
            </div>

            {form.filiere2 && (
              <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div className="form-group">
                  <label style={{ fontSize: '12px', fontWeight: '600' }}>Spécialité 2</label>
                  {getSpecialites2Disponibles(form.filiere2).length > 0 ? (
                    <select
                      name="specialite2"
                      value={form.specialite2 || ''}
                      onChange={(e) => onChange('specialite2', e.target.value)}
                    >
                      <option value="">Sélectionner la spécialité 2...</option>
                      {getSpecialites2Disponibles(form.filiere2).map((spec) => (
                        <option key={spec} value={spec}>{spec}</option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      name="specialite2"
                      placeholder="Saisir la spécialité 2..."
                      value={form.specialite2 || ''}
                      onChange={(e) => onChange('specialite2', e.target.value)}
                    />
                  )}
                </div>

                <div className="form-group">
                  <label style={{ fontSize: '12px', fontWeight: '600' }}>Option 2</label>
                  {getOptions2Disponibles(form.filiere2, form.specialite2).length > 0 ? (
                    <select
                      name="option2"
                      value={form.option2 || ''}
                      onChange={(e) => onChange('option2', e.target.value)}
                    >
                      <option value="">Sélectionner l'option 2...</option>
                      {getOptions2Disponibles(form.filiere2, form.specialite2).map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      name="option2"
                      placeholder="Saisir l'option 2..."
                      value={form.option2 || ''}
                      onChange={(e) => onChange('option2', e.target.value)}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const PartnersCreateEtudiant = () => {
  const [etudiants, setEtudiants] = useState([]);
  const [etudiantsFiltres, setEtudiantsFiltres] = useState([]);
  const [recherche, setRecherche] = useState('');
  const [filtreGenre, setFiltreGenre] = useState('');
  const [filtreCours, setFiltreCours] = useState('');
  const [filtreActif, setFiltreActif] = useState('');
  const [pageActuelle, setPageActuelle] = useState(1);
  const [etudiantsParPage] = useState(10);
  const [loading, setLoading] = useState(true);

  // États pour le verrouillage de l'auto-sélection des cours
  const [lockCoursAjout, setLockCoursAjout] = useState(false);
  const [lockCoursModifier, setLockCoursModifier] = useState(false);

  // États pour le modal d'ajout
  const [showModal, setShowModal] = useState(false);
  const [formAjout, setFormAjout] = useState({
    prenom: '',
    nomDeFamille: '',
    genre: 'Homme',
    dateNaissance: '',
    telephone: '',
    email: '',
    motDePasse: '',
    cin: '',
    passeport: '',
    anneeScolaire: genererAnneeScolaireActuelle(),
    lieuNaissance: '',
    lieuFormation: '',
    pays: '',
    cours: [],
    niveau: '',
    niveauFormation: '',
    filiere: '',
    option: '',
    specialite: '',
    typeDiplome: '',
    diplomeAcces: '',
    specialiteDiplomeAcces: '',
    mention: '',
    lieuObtentionDiplome: '',
    serieBaccalaureat: '',
    anneeBaccalaureat: '',
    premiereAnneeInscription: '',
    sourceInscription: '',
    dateInscription: '',
    typePaiement: '',
    prixTotal: '',
    pourcentageBourse: '',
    situation: '',
    codeEtudiant: '',
    dateEtReglement: '',
    actif: true,
    nouvelleInscription: true,
    paye: false,
    handicape: false,
    resident: false,
    fonctionnaire: false,
    mobilite: false,
    commercial: '',
    cycle: '',
    specialiteIngenieur: '',
    optionIngenieur: '',
    // Nouveaux champs pour le modèle backend
    specialiteLicencePro: '',
    optionLicencePro: '',
    specialiteMasterPro: '',
    optionMasterPro: '',
    // NOUVEAUX CHAMPS
    modePaiement: 'mensuel',
    telephoneResponsable: '',
    codeBaccalaureat: '',
    // NOUVEAUX CHAMPS PARTNER  
    isPartner: false,
    nomPartner: '',
    prixTotalPartner: '',
    // COMMENTAIRES POUR LES DOCUMENTS
    commentaireCin: '',
    commentaireBacCommentaire: '',
    commentaireReleveNoteBac: '',
    commentaireDiplomeCommentaire: '',
    commentaireAttestationReussiteCommentaire: '',
    commentaireReleveNotesFormationCommentaire: '',
    commentairePasseport: '',
    commentaireBacOuAttestationBacCommentaire: '',
    commentaireAuthentificationBac: '',
    commentaireAuthenticationDiplome: '',
    commentaireEngagementCommentaire: ''
  });

  const [vueMode, setVueMode] = useState('tableau');
  const [imageFile, setImageFile] = useState(null);
  const [listeCours, setListeCours] = useState([]);
  const [messageAjout, setMessageAjout] = useState('');
  const [loadingAjout, setLoadingAjout] = useState(false);

  // États pour le modal de visualisation
  const [showViewModal, setShowViewModal] = useState(false);
  const [etudiantSelectionne, setEtudiantSelectionne] = useState(null);

  // États pour l'export Excel
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportAnneeScolaire, setExportAnneeScolaire] = useState('');
  const [loadingExport, setLoadingExport] = useState(false);

  // États pour le modal de modification
  const [showEditModal, setShowEditModal] = useState(false);
  const [formModifier, setFormModifier] = useState({
    prenom: '',
    nomDeFamille: '',
    genre: 'Homme',
    dateNaissance: '',
    anneeScolaire: genererAnneeScolaireActuelle(),
    telephone: '',
    email: '',
    motDePasse: '',
    cin: '',
    passeport: '',
    lieuNaissance: '',
    lieuFormation: '',
    pays: '',
    cours: [],
    niveau: '',
    niveauFormation: '',
    filiere: '',
    option: '',
    specialite: '',
    typeDiplome: '',
    diplomeAcces: '',
    specialiteDiplomeAcces: '',
    mention: '',
    lieuObtentionDiplome: '',
    serieBaccalaureat: '',
    anneeBaccalaureat: '',
    premiereAnneeInscription: '',
    sourceInscription: '',
    dateInscription: '',
    typePaiement: '',
    prixTotal: '',
    pourcentageBourse: '',
    situation: '',
    codeEtudiant: '',
    dateEtReglement: '',
    actif: true,
    nouvelleInscription: true,
    paye: false,
    handicape: false,
    resident: false,
    fonctionnaire: false,
    mobilite: false,
    commercial: '',
    cycle: '',
    specialiteIngenieur: '',
    optionIngenieur: '',
    // Nouveaux champs pour le modèle backend
    specialiteLicencePro: '',
    optionLicencePro: '',
    specialiteMasterPro: '',
    optionMasterPro: '',
    // NOUVEAUX CHAMPS
    modePaiement: 'mensuel',
    telephoneResponsable: '',
    codeBaccalaureat: '',
    // NOUVEAUX CHAMPS PARTNER  
    isPartner: false,
    nomPartner: '',
    prixTotalPartner: '',
    // COMMENTAIRES POUR LES DOCUMENTS
    commentaireCin: '',
    commentaireBacCommentaire: '',
    commentaireReleveNoteBac: '',
    commentaireDiplomeCommentaire: '',
    commentaireAttestationReussiteCommentaire: '',
    commentaireReleveNotesFormationCommentaire: '',
    commentairePasseport: '',
    commentaireBacOuAttestationBacCommentaire: '',
    commentaireAuthentificationBac: '',
    commentaireAuthenticationDiplome: '',
    commentaireEngagementCommentaire: ''
  });

  const [imageFileModifier, setImageFileModifier] = useState(null);
  const [messageModifier, setMessageModifier] = useState('');
  const [loadingModifier, setLoadingModifier] = useState(false);
  const [etudiantAModifier, setEtudiantAModifier] = useState(null);

  const [filesAjout, setFilesAjout] = useState({
    fichierInscrit: null,
    originalBac: null,
    releveNotes: null,
    copieCni: null,
    passport: null,
    dtsBac2: null,
    licence: null,
    // NOUVEAUX DOCUMENTS
    documentCin: null,
    documentBacCommentaire: null,
    documentReleveNoteBac: null,
    documentDiplomeCommentaire: null,
    documentAttestationReussiteCommentaire: null,
    documentReleveNotesFormationCommentaire: null,
    documentPasseport: null,
    documentBacOuAttestationBacCommentaire: null,
    documentAuthentificationBac: null,
    documentAuthenticationDiplome: null,
    documentEngagementCommentaire: null
  });
  const [filesModifier, setFilesModifier] = useState({
    fichierInscrit: null,
    originalBac: null,
    releveNotes: null,
    copieCni: null,
    passport: null,
    dtsBac2: null,
    licence: null,
    // NOUVEAUX DOCUMENTS
    documentCin: null,
    documentBacCommentaire: null,
    documentReleveNoteBac: null,
    documentDiplomeCommentaire: null,
    documentAttestationReussiteCommentaire: null,
    documentReleveNotesFormationCommentaire: null,
    documentPasseport: null,
    documentBacOuAttestationBacCommentaire: null,
    documentAuthentificationBac: null,
    documentAuthenticationDiplome: null,
    documentEngagementCommentaire: null
  });

  // États pour la visibilité des mots de passe
  const [showPasswordAjout, setShowPasswordAjout] = useState(false);
  const [showPasswordModifier, setShowPasswordModifier] = useState(false);

  const navigate = useNavigate();

  // Handlers pour la formation intelligente
  const handleFormationChangeAjout = handleFormationChange(setFormAjout, formAjout);
  const handleFormationChangeModifier = handleFormationChange(setFormModifier, formModifier);

  useEffect(() => {
    fetchEtudiants();
    fetchCours();

  }, []);

  useEffect(() => {
    filtrerEtudiants();
  }, [etudiants, recherche, filtreGenre, filtreCours, filtreActif]);

  // Auto-assign pour AJOUT
  useEffect(() => {
    autoAssignCours(formAjout, setFormAjout, listeCours, lockCoursAjout);
  }, [
    formAjout.niveauFormation,
    formAjout.filiere, formAjout.niveau,
    formAjout.specialite, formAjout.option,
    formAjout.cycle, formAjout.specialiteIngenieur, formAjout.optionIngenieur,
    formAjout.specialiteLicencePro, formAjout.optionLicencePro,
    formAjout.specialiteMasterPro, formAjout.optionMasterPro,
    listeCours, lockCoursAjout
  ]);

  // Auto-assign pour MODIFICATION
  useEffect(() => {
    autoAssignCours(formModifier, setFormModifier, listeCours, lockCoursModifier);
  }, [
    formModifier.niveauFormation,
    formModifier.filiere, formModifier.niveau,
    formModifier.specialite, formModifier.option,
    formModifier.cycle, formModifier.specialiteIngenieur, formModifier.optionIngenieur,
    formModifier.specialiteLicencePro, formModifier.optionLicencePro,
    formModifier.specialiteMasterPro, formModifier.optionMasterPro,
    listeCours, lockCoursModifier
  ]);

  // Génération automatique du code étudiant pour l'ajout
  useEffect(() => {
    if (formAjout.filiere && formAjout.prenom && formAjout.nomDeFamille) {
      const codeGenere = genererCodeEtudiantMisAJour(formAjout);
      if (codeGenere !== formAjout.codeEtudiant) {
        setFormAjout(prev => ({ ...prev, codeEtudiant: codeGenere }));
      }
    }
  }, [formAjout.filiere, formAjout.niveau, formAjout.prenom, formAjout.nomDeFamille, formAjout.specialiteIngenieur]);

  // Génération automatique du code étudiant pour la modification
  useEffect(() => {
    if (formModifier.filiere && formModifier.prenom && formModifier.nomDeFamille) {
      const codeGenere = genererCodeEtudiantMisAJour(formModifier);
      if (!formModifier.codeEtudiant) {
        setFormModifier(prev => ({ ...prev, codeEtudiant: codeGenere }));
      }
    }
  }, [formModifier.filiere, formModifier.niveau, formModifier.prenom, formModifier.nomDeFamille, formModifier.specialiteIngenieur]);

  const fetchEtudiants = async () => {
    // Declare token at function level so it's accessible everywhere
    const token = localStorage.getItem('token');

    try {
      setLoading(true);

      if (!token) {
        console.error('No authentication token found');
        setEtudiants([]);
        return;
      }

      // First, try the new partner-specific route
      const res = await axios.get('    https://vmi1977988.contaboserver.net/api2/partners/etudiants', {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('Partner students loaded:', res.data.length);
      setEtudiants(res.data);

    } catch (err) {
      console.error('Error fetching partner students:', err);

      // token is now accessible here since it was declared at function level

      // Check if it's an authentication issue
      if (err.response?.status === 401) {
        console.error('Authentication failed - token may be expired');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setMessageAjout('❌ Session expirée. Veuillez vous reconnecter.');
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
        return;
      }

      // Check if it's a permission issue
      if (err.response?.status === 403) {
        console.error('Access forbidden - user may not be a partner');
        setMessageAjout('❌ Accès interdit. Compte partner inactif ou non autorisé.');
        setEtudiants([]);
        return;
      }

      // Check if route not found (fallback for older backend versions)
      if (err.response?.status === 404) {
        console.log('Partner route not found, trying fallback...');
        try {
          // Try the older commercial route as fallback
          const fallbackRes = await axios.get('    https://vmi1977988.contaboserver.net/api2/partnersetudiants', {
            headers: { Authorization: `Bearer ${token}` } // token is accessible here now
          });

          console.log('Students loaded via fallback route:', fallbackRes.data.length);
          setEtudiants(fallbackRes.data);
          return;

        } catch (fallbackErr) {
          console.error('Fallback route also failed:', fallbackErr);
          setMessageAjout('❌ Impossible de charger les étudiants. Contactez l\'administrateur.');
          setEtudiants([]);
          return;
        }
      }

      // For any other error, show appropriate message
      setMessageAjout('❌ Erreur lors du chargement des étudiants: ' + (err.response?.data?.message || err.message));
      setEtudiants([]);

    } finally {
      setLoading(false);
    }
  };
  const fetchCours = async () => {
    try {
      const token = localStorage.getItem('token');

      // CORRECTION 3: Try partner/admin course route first
      const res = await axios.get('    https://vmi1977988.contaboserver.net/api2/partnerscours', {
        headers: { Authorization: `Bearer ${token}` }
      });

      setListeCours(res.data);
    } catch (err) {
      console.error('Erreur lors du chargement des cours:', err);

      // CORRECTION 4: Fallback to basic courses route
      if (err.response?.status === 404) {
        try {
          const fallbackRes = await axios.get('    https://vmi1977988.contaboserver.net/api2/cours', {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          });
          setListeCours(fallbackRes.data);
        } catch (fallbackErr) {
          console.error('Erreur fallback cours:', fallbackErr);
          setListeCours([]);
        }
      } else {
        setListeCours([]);
      }
    }
  };






  const getNomPartner = (nomPartner) => {
    if (!nomPartner) return 'Aucun';
    if (typeof nomPartner === 'object' && nomPartner.nomPartner) {
      return nomPartner.nomPartner;
    }
    if (typeof nomPartner === 'object' && nomPartner._id) {
      return nomPartner.nom || 'Partner';
    }
    return nomPartner;
  };

  const getCoursFiltre = (listeCours, form) => {
    if (!form.filiere || !listeCours.length) return [];
    const candidats = buildCoursCandidates(form);
    if (!candidats.length) return [];

    return listeCours.filter(cours => {
      const nomCours = normalize(cours.nom || cours);
      return candidats.some(candidat => {
        const nc = normalize(candidat);
        return nomCours.includes(nc) || nc.includes(nomCours);
      });
    });
  };

  const filtrerEtudiants = () => {
    let resultats = etudiants;

    // Filtre par recherche (prénom, nom de famille, téléphone, email)
    if (recherche) {
      resultats = resultats.filter(e => {
        const nomComplet = `${e.prenom || ''} ${e.nomDeFamille || ''}`.toLowerCase();
        return (
          nomComplet.includes(recherche.toLowerCase()) ||
          (e.telephone && e.telephone.includes(recherche)) ||
          (e.email && e.email.toLowerCase().includes(recherche.toLowerCase())) ||
          (e.cin && e.cin.toLowerCase().includes(recherche.toLowerCase())) ||
          (e.lieuFormation && e.lieuFormation.toLowerCase().includes(recherche.toLowerCase())) ||
          (e.codeEtudiant && e.codeEtudiant.toLowerCase().includes(recherche.toLowerCase()))
        );
      });
    }

    if (filtreGenre) {
      resultats = resultats.filter(e => e.genre === filtreGenre);
    }

    if (filtreCours) {
      resultats = resultats.filter(e =>
        e.cours && e.cours.some(cours => cours.toLowerCase().includes(filtreCours.toLowerCase()))
      );
    }

    if (filtreActif !== '') {
      resultats = resultats.filter(e => e.actif === (filtreActif === 'true'));
    }

    setEtudiantsFiltres(resultats);
    setPageActuelle(1);
  };
  const coursFiltres = getCoursFiltre(listeCours, formAjout);
  const coursFiltresModif = getCoursFiltre(listeCours, formModifier);

  // Fonctions pour le modal d'ajout
  const openModal = () => {
    setShowModal(true);
    setMessageAjout('');
    setLockCoursAjout(false);
  };

  const closeModal = () => {
    setShowModal(false);
    setFormAjout({
      prenom: '',
      nomDeFamille: '',
      genre: 'Homme',
      dateNaissance: '',
      telephone: '',
      email: '',
      motDePasse: '',
      cin: '',
      passeport: '',
      anneeScolaire: genererAnneeScolaireActuelle(),
      lieuNaissance: '',
      lieuFormation: '',
      pays: '',
      cours: [],
      niveau: '',
      niveauFormation: '',
      filiere: '',
      option: '',
      specialite: '',
      typeDiplome: '',
      diplomeAcces: '',
      specialiteDiplomeAcces: '',
      mention: '',
      lieuObtentionDiplome: '',
      serieBaccalaureat: '',
      anneeBaccalaureat: '',
      premiereAnneeInscription: '',
      sourceInscription: '',
      dateInscription: '',
      typePaiement: '',
      prixTotal: '',
      pourcentageBourse: '',
      situation: '',
      codeEtudiant: '',
      dateEtReglement: '',
      numRecu: '',
      actif: true,
      nouvelleInscription: true,
      paye: false,
      handicape: false,
      resident: false,
      fonctionnaire: false,
      mobilite: false,
      commercial: '',
      cycle: '',
      specialiteIngenieur: '',
      optionIngenieur: '',
      // Nouveaux champs pour le modèle backend
      specialiteLicencePro: '',
      optionLicencePro: '',
      specialiteMasterPro: '',
      optionMasterPro: '',
      // NOUVEAUX CHAMPS
      modePaiement: 'mensuel',
      telephoneResponsable: '',
      codeBaccalaureat: '',
      // NOUVEAUX CHامPS PARTNER  
      isPartner: false,
      nomPartner: '',
      prixTotalPartner: '',
      // COMMENTAIRES POUR LES DOCUMENTS
      commentaireCin: '',
      commentaireBacCommentaire: '',
      commentaireReleveNoteBac: '',
      commentaireDiplomeCommentaire: '',
      commentaireAttestationReussiteCommentaire: '',
      commentaireReleveNotesFormationCommentaire: '',
      commentairePasseport: '',
      commentaireBacOuAttestationBacCommentaire: '',
      commentaireAuthentificationBac: '',
      commentaireAuthenticationDiplome: '',
      commentaireEngagementCommentaire: ''
    });
    setFilesAjout({
      fichierInscrit: null,
      originalBac: null,
      releveNotes: null,
      copieCni: null,
      passport: null,
      dtsBac2: null,
      licence: null,
      // NOUVEAUX DOCUMENTS
      documentCin: null,
      documentBacCommentaire: null,
      documentReleveNoteBac: null,
      documentDiplomeCommentaire: null,
      documentAttestationReussiteCommentaire: null,
      documentReleveNotesFormationCommentaire: null,
      documentPasseport: null,
      documentBacOuAttestationBacCommentaire: null,
      documentAuthentificationBac: null,
      documentAuthenticationDiplome: null,
      documentEngagementCommentaire: null
    });
    setImageFile(null);
    setMessageAjout('');
    setLockCoursAjout(false);
  };

  // Fonctions pour le modal de modification
  const openEditModal = (etudiant) => {
    const rawDateInscription = etudiant.dateInscription || etudiant.createdAt;
    const dateInscriptionFormatted = rawDateInscription
      ? (typeof rawDateInscription === 'string' ? rawDateInscription.slice(0, 10) : new Date(rawDateInscription).toISOString().slice(0, 10))
      : '';
    const dateNaissanceFormatted = etudiant.dateNaissance
      ? (typeof etudiant.dateNaissance === 'string' ? etudiant.dateNaissance.slice(0, 10) : new Date(etudiant.dateNaissance).toISOString().slice(0, 10))
      : '';

    setEtudiantAModifier(etudiant);
    setFormModifier({
      prenom: etudiant.prenom || '',
      nomDeFamille: etudiant.nomDeFamille || '',
      genre: etudiant.genre || 'Homme',
      dateNaissance: dateNaissanceFormatted,
      telephone: etudiant.telephone || '',
      email: etudiant.email || '',
      motDePasse: '',
      cin: etudiant.cin || '',
      passeport: etudiant.passeport || '',
      lieuNaissance: etudiant.lieuNaissance || '',
      lieuFormation: etudiant.lieuFormation || '',
      pays: etudiant.pays || '',
      cours: etudiant.cours || [],
      niveau: etudiant.niveau || '',
      niveauFormation: etudiant.niveauFormation || '',
      filiere: etudiant.filiere || '',
      option: etudiant.option || '',
      specialite: etudiant.specialite || '',
      typeDiplome: etudiant.typeDiplome || '',
      diplomeAcces: etudiant.diplomeAcces || '',
      specialiteDiplomeAcces: etudiant.specialiteDiplomeAcces || '',
      mention: etudiant.mention || '',
      lieuObtentionDiplome: etudiant.lieuObtentionDiplome || '',
      serieBaccalaureat: etudiant.serieBaccalaureat || '',
      anneeBaccalaureat: etudiant.anneeBaccalaureat || '',
      premiereAnneeInscription: etudiant.premiereAnneeInscription || '',
      sourceInscription: etudiant.sourceInscription || '',
      dateInscription: dateInscriptionFormatted,
      typePaiement: etudiant.typePaiement || '',
      prixTotal: etudiant.prixTotal || '',
      pourcentageBourse: etudiant.pourcentageBourse || '',
      fraisInscription: etudiant.fraisInscription != null ? etudiant.fraisInscription : 3000,
      fraisScolariteBase: etudiant.fraisScolariteBase != null ? etudiant.fraisScolariteBase : 35000,
      typeRemise: etudiant.typeRemise || 'none',
      remiseMontant: etudiant.remiseMontant != null ? etudiant.remiseMontant : (etudiant.remise != null ? etudiant.remise : 0),
      situation: etudiant.situation || '',
      codeEtudiant: etudiant.codeEtudiant || '',
      dateEtReglement: etudiant.dateEtReglement || '',
      numRecu: etudiant.numRecu || '',
      actif: etudiant.actif ?? true,
      nouvelleInscription: etudiant.nouvelleInscription ?? true,
      paye: etudiant.paye ?? false,
      handicape: etudiant.handicape ?? false,
      resident: etudiant.resident ?? false,
      fonctionnaire: etudiant.fonctionnaire ?? false,
      mobilite: etudiant.mobilite ?? false,
      commercial: etudiant.commercial?._id || etudiant.commercial || '',
      cycle: etudiant.cycle || (etudiant.filiere === 'CYCLE_INGENIEUR' && etudiant.niveau ? getCycleParNiveau(etudiant.niveau) : ''),
      specialiteIngenieur: etudiant.specialiteIngenieur || (etudiant.filiere === 'CYCLE_INGENIEUR' && ['Génie Informatique', 'Génie Mécatronique', 'Génie Civil'].includes(etudiant.specialite) ? etudiant.specialite : '') || '',
      optionIngenieur: etudiant.optionIngenieur || '',
      nomPartner: etudiant.nomPartner?._id || etudiant.nomPartner || '',
      // Nouveaux champs pour le modèle backend
      specialiteLicencePro: etudiant.specialiteLicencePro || '',
      optionLicencePro: etudiant.optionLicencePro || '',
      specialiteMasterPro: etudiant.specialiteMasterPro || '',
      optionMasterPro: etudiant.optionMasterPro || '',
      // NOUVEAUX CHAMPS
      modePaiement: etudiant.modePaiement || 'mensuel',
      telephoneResponsable: etudiant.telephoneResponsable || '',
      codeBaccalaureat: etudiant.codeBaccalaureat || '',
      // NOUVEAUX CHAMPS PARTNER  
      isPartner: etudiant.isPartner || false,
      prixTotalPartner: etudiant.prixTotalPartner || '',
      // COMMENTAIRES POUR LES DOCUMENTS
      commentaireCin: etudiant.documents?.cin?.commentaire || '',
      commentaireBacCommentaire: etudiant.documents?.bacCommentaire?.commentaire || '',
      commentaireReleveNoteBac: etudiant.documents?.releveNoteBac?.commentaire || '',
      commentaireDiplomeCommentaire: etudiant.documents?.diplomeCommentaire?.commentaire || '',
      commentaireAttestationReussiteCommentaire: etudiant.documents?.attestationReussiteCommentaire?.commentaire || '',
      commentaireReleveNotesFormationCommentaire: etudiant.documents?.releveNotesFormationCommentaire?.commentaire || '',
      commentairePasseport: etudiant.documents?.passeport?.commentaire || '',
      commentaireBacOuAttestationBacCommentaire: etudiant.documents?.bacOuAttestationBacCommentaire?.commentaire || '',
      commentaireAuthentificationBac: etudiant.documents?.authentificationBac?.commentaire || '',
      commentaireAuthenticationDiplome: etudiant.documents?.authenticationDiplome?.commentaire || '',
      commentaireEngagementCommentaire: etudiant.documents?.engagementCommentaire?.commentaire || ''
    });
    setImageFileModifier(null);
    setMessageModifier('');
    setShowEditModal(true);
    setLockCoursModifier(false);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEtudiantAModifier(null);
    setFormModifier({
      prenom: '',
      nomDeFamille: '',
      genre: 'Homme',
      dateNaissance: '',
      telephone: '',
      anneeScolaire: genererAnneeScolaireActuelle(),
      email: '',
      motDePasse: '',
      cin: '',
      passeport: '',
      lieuNaissance: '',
      lieuFormation: '',
      pays: '',
      cours: [],
      niveau: '',
      niveauFormation: '',
      filiere: '',
      option: '',
      specialite: '',
      typeDiplome: '',
      diplomeAcces: '',
      specialiteDiplomeAcces: '',
      mention: '',
      lieuObtentionDiplome: '',
      serieBaccalaureat: '',
      anneeBaccalaureat: '',
      premiereAnneeInscription: '',
      sourceInscription: '',
      dateInscription: '',
      typePaiement: '',
      prixTotal: '',
      pourcentageBourse: '',
      situation: '',
      codeEtudiant: '',
      dateEtReglement: '',
      actif: true,
      nouvelleInscription: true,
      paye: false,
      handicape: false,
      resident: false,
      fonctionnaire: false,
      mobilite: false,
      commercial: '',
      cycle: '',
      specialiteIngenieur: '',
      optionIngenieur: '',
      nomPartner: '',
      // Nouveaux champs pour le modèle backend
      specialiteLicencePro: '',
      optionLicencePro: '',
      specialiteMasterPro: '',
      optionMasterPro: '',
      // NOUVEAUX CHامPS PARTNER  
      isPartner: false,
      nomPartner: '',
      prixTotalPartner: '',
      // COMMENTAIRES POUR LES DOCUMENTS
      commentaireCin: '',
      commentaireBacCommentaire: '',
      commentaireReleveNoteBac: '',
      commentaireDiplomeCommentaire: '',
      commentaireAttestationReussiteCommentaire: '',
      commentaireReleveNotesFormationCommentaire: '',
      commentairePasseport: '',
      commentaireBacOuAttestationBacCommentaire: '',
      commentaireAuthentificationBac: '',
      commentaireAuthenticationDiplome: '',
      commentaireEngagementCommentaire: ''
    });
    setFilesModifier({
      fichierInscrit: null,
      originalBac: null,
      releveNotes: null,
      copieCni: null,
      passport: null,
      dtsBac2: null,
      licence: null,
      // NOUVEAUX DOCUMENTS
      documentCin: null,
      documentBacCommentaire: null,
      documentReleveNoteBac: null,
      documentDiplomeCommentaire: null,
      documentAttestationReussiteCommentaire: null,
      documentReleveNotesFormationCommentaire: null,
      documentPasseport: null,
      documentBacOuAttestationBacCommentaire: null,
      documentAuthentificationBac: null,
      documentAuthenticationDiplome: null,
      documentEngagementCommentaire: null
    });
    setImageFileModifier(null);
    setMessageModifier('');
    setLockCoursModifier(false);
  };

  // Handler de changement pour inclure les champs ingénieur et les nouveaux champs
  const handleChangeAjout = (e) => {
    const { name, value, type, checked } = e.target;
    if ([
      'niveau', 'filiere', 'specialite', 'option', 'cycle',
      'specialiteIngenieur', 'optionIngenieur',
      'specialiteLicencePro', 'optionLicencePro',
      'specialiteMasterPro', 'optionMasterPro',
      'niveauFormation'
    ].includes(name)) {
      setLockCoursAjout(false);
      handleFormationChangeAjout(name, type === 'checkbox' ? checked : value);
    } else {
      // Handle boolean fields
      const booleanFields = ['isPartner', 'actif', 'paye', 'handicape', 'resident', 'fonctionnaire', 'mobilite', 'nouvelleInscription'];
      const newValue = booleanFields.includes(name) ? (type === 'checkbox' ? checked : value === 'true') : value;

      setFormAjout({ ...formAjout, [name]: newValue });

      // Auto-set paye to true if modePaiement is 'annuel'
      if (name === 'modePaiement' && value === 'annuel') {
        setFormAjout(prev => ({ ...prev, [name]: value, paye: true }));
      }
    }
  };

  const handleChangeModifier = (e) => {
    const { name, value, type, checked } = e.target;
    if ([
      'niveau', 'filiere', 'specialite', 'option', 'cycle',
      'specialiteIngenieur', 'optionIngenieur',
      'specialiteLicencePro', 'optionLicencePro',
      'specialiteMasterPro', 'optionMasterPro',
      'niveauFormation'
    ].includes(name)) {
      setLockCoursModifier(false);
      handleFormationChangeModifier(name, type === 'checkbox' ? checked : value);
    } else {
      // Handle boolean fields
      const booleanFields = ['isPartner', 'actif', 'paye', 'handicape', 'resident', 'fonctionnaire', 'mobilite', 'nouvelleInscription'];
      const newValue = booleanFields.includes(name) ? (type === 'checkbox' ? checked : value === 'true') : value;

      setFormModifier({ ...formModifier, [name]: newValue });

      // Auto-set paye to true if modePaiement is 'annuel'
      if (name === 'modePaiement' && value === 'annuel') {
        setFormModifier(prev => ({ ...prev, [name]: value, paye: true }));
      }
    }
  };

  const handleSelectCoursAjout = (coursNom) => {
    const nouveauxCours = formAjout.cours.includes(coursNom)
      ? formAjout.cours.filter(c => c !== coursNom)
      : [...formAjout.cours, coursNom];
    setFormAjout({ ...formAjout, cours: nouveauxCours });
    setLockCoursAjout(true);
  };

  const handleImageChangeAjout = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleFileChangeAjout = (e) => {
    const { name, files } = e.target;
    setFilesAjout(prev => ({
      ...prev,
      [name]: files[0] || null
    }));
  };

  const handleSubmitAjout = async (e) => {
    e.preventDefault();

    if (!formAjout.numRecu || !formAjout.numRecu.trim()) {
      setMessageAjout('❌ Le numéro de reçu est obligatoire.');
      return;
    }

    // Validation (keep existing validation code...)
    const erreurAnneeScolaire = validerAnneeScolaire(formAjout.anneeScolaire);
    if (erreurAnneeScolaire) {
      setMessageAjout('❌ ' + erreurAnneeScolaire);
      return;
    }

    if (formAjout.filiere === 'CYCLE_INGENIEUR' && !formAjout.cycle && formAjout.niveau) {
      formAjout.cycle = getCycleParNiveau(formAjout.niveau);
    }

    const erreursFormation = validerFormationComplete(formAjout);
    if (erreursFormation.length > 0) {
      setMessageAjout('❌ Erreurs de formation: ' + erreursFormation.join(', '));
      return;
    }

    // 🔍 Vérification anti-doublon locale (CIN, Téléphone, Nom + Prénom + Date de naissance)
    if (formAjout.cin && formAjout.cin.trim()) {
      const cinClean = formAjout.cin.replace(/\s+/g, '').toLowerCase();
      const doublonCin = etudiants.find(e => e.cin && e.cin.replace(/\s+/g, '').toLowerCase() === cinClean);
      if (doublonCin) {
        setMessageAjout(`❌ Doublon détecté : Un étudiant avec ce numéro de CIN (${formAjout.cin.trim()}) existe déjà (${doublonCin.nomDeFamille?.toUpperCase()} ${doublonCin.prenom}).`);
        return;
      }
    }
    if (formAjout.telephone && formAjout.telephone.trim()) {
      const telDigits = formAjout.telephone.replace(/\D/g, '');
      if (telDigits.length >= 8) {
        const telSuffix = telDigits.slice(-9);
        const doublonTel = etudiants.find(e => e.telephone && e.telephone.replace(/\D/g, '').includes(telSuffix));
        if (doublonTel) {
          setMessageAjout(`❌ Doublon détecté : Un étudiant avec ce numéro de téléphone (${formAjout.telephone.trim()}) existe déjà (${doublonTel.nomDeFamille?.toUpperCase()} ${doublonTel.prenom}).`);
          return;
        }
      }
    }
    if (formAjout.nomDeFamille && formAjout.prenom && formAjout.dateNaissance) {
      const nom = formAjout.nomDeFamille.trim().toLowerCase();
      const prenom = formAjout.prenom.trim().toLowerCase();
      const dobStr = formAjout.dateNaissance.slice(0, 10);
      const doublonIdentite = etudiants.find(e => {
        const eNom = (e.nomDeFamille || '').trim().toLowerCase();
        const ePrenom = (e.prenom || '').trim().toLowerCase();
        const eDobStr = e.dateNaissance ? (typeof e.dateNaissance === 'string' ? e.dateNaissance.slice(0, 10) : new Date(e.dateNaissance).toISOString().slice(0, 10)) : '';
        return ((eNom === nom && ePrenom === prenom) || (eNom === prenom && ePrenom === nom)) && eDobStr === dobStr;
      });
      if (doublonIdentite) {
        setMessageAjout(`❌ Doublon détecté : Un étudiant avec les mêmes nom, prénom et date de naissance existe déjà (${doublonIdentite.nomDeFamille?.toUpperCase()} ${doublonIdentite.prenom}).`);
        return;
      }
    }

    setLoadingAjout(true);

    // Get token once at the beginning
    const token = localStorage.getItem('token');

    if (!token) {
      setMessageAjout('❌ Token d\'authentification manquant');
      setLoadingAjout(false);
      return;
    }

    try {
      const formData = new FormData();

      // Always set as partner with current user as nomPartner
      formData.append('isPartner', 'true');
      // Don't manually set nomPartner - let backend handle it

      Object.keys(formAjout).forEach(key => {
        if (key === 'cours') {
          formAjout[key].forEach(c => formData.append('cours[]', c));
        } else if (key !== 'isPartner' && key !== 'nomPartner') {
          const valeur = formAjout[key];
          const valeurAEnvoyer = (valeur !== undefined && valeur !== null)
            ? (typeof valeur === 'boolean' ? valeur.toString() : valeur.toString())
            : '';
          formData.append(key, valeurAEnvoyer);
        }
      });

      if (imageFile) formData.append('image', imageFile);
      Object.keys(filesAjout).forEach(key => {
        if (filesAjout[key]) {
          formData.append(key, filesAjout[key]);
        }
      });

      // Try partner creation endpoint
      const response = await axios.post('    https://vmi1977988.contaboserver.net/api2/partners/etudiants', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      setMessageAjout('✅ Étudiant ajouté avec succès');
      setEtudiants([...etudiants, response.data]);
      await fetchEtudiants();

      setTimeout(() => {
        closeModal();
      }, 2000);

    } catch (err) {
      console.error('Erreur création étudiant partner:', err);

      // Fallback to commercial route if partner route fails
      if (err.response?.status === 404) {
        try {
          // Use commercial route as fallback - token is already defined above
          const fallbackFormData = new FormData();

          // Mark as partner student
          fallbackFormData.append('isPartner', 'true');
          fallbackFormData.append('prixTotalPartner', formAjout.prixTotalPartner || '0');

          Object.keys(formAjout).forEach(key => {
            if (key === 'cours') {
              formAjout[key].forEach(c => fallbackFormData.append('cours[]', c));
            } else {
              const valeur = formAjout[key];
              const valeurAEnvoyer = (valeur !== undefined && valeur !== null)
                ? (typeof valeur === 'boolean' ? valeur.toString() : valeur.toString())
                : '';
              fallbackFormData.append(key, valeurAEnvoyer);
            }
          });

          if (imageFile) fallbackFormData.append('image', imageFile);
          Object.keys(filesAjout).forEach(key => {
            if (filesAjout[key]) {
              fallbackFormData.append(key, filesAjout[key]);
            }
          });

          const fallbackResponse = await axios.post('    https://vmi1977988.contaboserver.net/api2/partnersetudiants', fallbackFormData, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data'
            }
          });

          setMessageAjout('✅ Étudiant ajouté avec succès (via route de secours)');
          await fetchEtudiants();
          setTimeout(() => closeModal(), 2000);

        } catch (fallbackErr) {
          const errMsg = fallbackErr.response?.data?.message || fallbackErr.response?.data?.error || fallbackErr.response?.data?.details || fallbackErr.message || 'Erreur inconnue';
          setMessageAjout('❌ Erreur: ' + errMsg);
        }
      } else if (err.response?.status === 401) {
        setMessageAjout('❌ Session expirée. Veuillez vous reconnecter.');
        setTimeout(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/';
        }, 2000);
      } else if (err.response?.status === 403) {
        setMessageAjout('❌ Accès interdit. Compte partner inactif ou non autorisé.');
      } else {
        const errMsg = err.response?.data?.message || err.response?.data?.error || err.response?.data?.details || err.message || 'Erreur inconnue';
        setMessageAjout('❌ Erreur: ' + errMsg);
      }
    } finally {
      setLoadingAjout(false);
    }
  };

  const handleSelectCoursModifier = (coursNom) => {
    const nouveauxCours = formModifier.cours.includes(coursNom)
      ? formModifier.cours.filter(c => c !== coursNom)
      : [...formModifier.cours, coursNom];
    setFormModifier({ ...formModifier, cours: nouveauxCours });
    setLockCoursModifier(true);
  };

  const handleImageChangeModifier = (e) => {
    setImageFileModifier(e.target.files[0]);
  };

  const handleFileChangeModifier = (e) => {
    const { name, files } = e.target;
    setFilesModifier(prev => ({
      ...prev,
      [name]: files[0] || null
    }));
  };

  const handleSubmitModifier = async (e) => {
    e.preventDefault();

    if (!formModifier.numRecu || !formModifier.numRecu.trim()) {
      setMessageModifier('❌ Le numéro de reçu est obligatoire.');
      setLoadingModifier(false);
      return;
    }

    // Validation
    const erreurAnneeScolaire = validerAnneeScolaire(formModifier.anneeScolaire);
    if (erreurAnneeScolaire) {
      setMessageModifier('❌ ' + erreurAnneeScolaire);
      return;
    }

    if (formModifier.filiere === 'CYCLE_INGENIEUR' && !formModifier.cycle && formModifier.niveau) {
      formModifier.cycle = getCycleParNiveau(formModifier.niveau);
    }

    const erreursFormation = validerFormationComplete(formModifier);
    if (erreursFormation.length > 0) {
      setMessageModifier('❌ Erreurs de formation: ' + erreursFormation.join(', '));
      return;
    }

    setLoadingModifier(true);

    // Get token once at the beginning
    const token = localStorage.getItem('token');

    if (!token) {
      setMessageModifier('❌ Token d\'authentification manquant');
      setLoadingModifier(false);
      return;
    }

    try {
      const formData = new FormData();

      // Always set as partner
      formData.append('isPartner', 'true');

      Object.keys(formModifier).forEach(key => {
        if (key === 'cours') {
          formModifier[key].forEach(c => formData.append('cours[]', c));
        } else if (key === 'motDePasse' && formModifier[key].trim() === '') {
          return; // Skip empty password
        } else if (key !== 'isPartner' && key !== 'nomPartner') {
          const valeur = formModifier[key];
          formData.append(
            key,
            typeof valeur === 'boolean'
              ? valeur.toString()
              : (valeur !== undefined ? valeur : '')
          );
        }
      });

      if (imageFileModifier) formData.append('image', imageFileModifier);
      Object.keys(filesModifier).forEach(key => {
        if (filesModifier[key]) {
          formData.append(key, filesModifier[key]);
        }
      });

      // Try partner update endpoint
      const response = await axios.put(`     https://vmi1977988.contaboserver.net/api2/partners/etudiants/${etudiantAModifier._id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      setMessageModifier('✅ Étudiant modifié avec succès');
      await fetchEtudiants();
      setTimeout(() => closeEditModal(), 2000);

    } catch (err) {
      console.error('Erreur modification étudiant partner:', err);

      // Fallback to commercial route if partner route fails
      if (err.response?.status === 404) {
        try {
          // Use commercial route as fallback - token is already defined above
          const fallbackFormData = new FormData();

          fallbackFormData.append('isPartner', 'true');

          Object.keys(formModifier).forEach(key => {
            if (key === 'cours') {
              formModifier[key].forEach(c => fallbackFormData.append('cours[]', c));
            } else if (key === 'motDePasse' && formModifier[key].trim() === '') {
              return;
            } else {
              const valeur = formModifier[key];
              fallbackFormData.append(
                key,
                typeof valeur === 'boolean'
                  ? valeur.toString()
                  : (valeur !== undefined ? valeur : '')
              );
            }
          });

          if (imageFileModifier) fallbackFormData.append('image', imageFileModifier);
          Object.keys(filesModifier).forEach(key => {
            if (filesModifier[key]) {
              fallbackFormData.append(key, filesModifier[key]);
            }
          });

          await axios.put(`     https://vmi1977988.contaboserver.net/api2/partnersetudiants/${etudiantAModifier._id}`, fallbackFormData, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data'
            }
          });

          setMessageModifier('✅ Étudiant modifié avec succès (via route de secours)');
          await fetchEtudiants();
          setTimeout(() => closeEditModal(), 2000);

        } catch (fallbackErr) {
          setMessageModifier('❌ Erreur: ' + (fallbackErr.response?.data?.message || fallbackErr.response?.data?.error || fallbackErr.message || 'Erreur inconnue'));
        }
      } else if (err.response?.status === 401) {
        setMessageModifier('❌ Session expirée. Veuillez vous reconnecter.');
        setTimeout(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/';
        }, 2000);
      } else if (err.response?.status === 403) {
        setMessageModifier('❌ Accès interdit. Compte partner inactif ou non autorisé.');
      } else {
        setMessageModifier('❌ Erreur: ' + (err.response?.data?.message || err.response?.data?.error || err.message || 'Erreur inconnue'));
      }
    } finally {
      setLoadingModifier(false);
    }
  };





  const handleToggleActif = async (id) => {
    try {
      const token = localStorage.getItem('token');

      // Try partner route first
      let res;
      try {
        res = await axios.patch(`     https://vmi1977988.contaboserver.net/api2/partners/etudiants/${id}/actif`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } catch (err) {
        if (err.response?.status === 404) {
          // Fallback to commercial route
          res = await axios.patch(`     https://vmi1977988.contaboserver.net/api2/partnersetudiants/${id}/actif`, {}, {
            headers: { Authorization: `Bearer ${token}` }
          });
        } else {
          throw err;
        }
      }

      setEtudiants(etudiants.map(e => e._id === id ? res.data : e));
    } catch (err) {
      console.error('Erreur toggle actif:', err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("🛑 Êtes-vous sûr de vouloir supprimer cet étudiant ?")) return;

    try {
      const token = localStorage.getItem('token');

      // Try partner route first
      try {
        await axios.delete(`     https://vmi1977988.contaboserver.net/api2/partners/etudiants/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } catch (err) {
        if (err.response?.status === 404) {
          // Fallback to commercial route
          await axios.delete(`     https://vmi1977988.contaboserver.net/api2/partnersetudiants/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
        } else {
          throw err;
        }
      }

      setEtudiants(etudiants.filter(e => e._id !== id));
    } catch (err) {
      console.error('Erreur suppression:', err);
    }
  };



  const handleEdit = (etudiant) => {
    openEditModal(etudiant);
  };

  const handleView = (etudiant) => {
    setEtudiantSelectionne(etudiant);
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setEtudiantSelectionne(null);
  };

  const viderFiltres = () => {
    setRecherche('');
    setFiltreGenre('');
    setFiltreCours('');
    setFiltreActif('');
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return 'N/A';
    const date = new Date(isoDate);
    const jour = String(date.getDate()).padStart(2, '0');
    const mois = String(date.getMonth() + 1).padStart(2, '0');
    const annee = date.getFullYear();
    return `${jour}-${mois}-${annee}`;
  };

  const calculerAge = (dateNaissance) => {
    if (!dateNaissance) return 'N/A';
    const dob = new Date(dateNaissance);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  };



  const getNomComplet = (etudiant) => {
    return `${etudiant.nomDeFamille || ''} ${etudiant.prenom || ''}`.trim();
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/';
  };

  const exportToExcel = async () => {
    try {
      setLoadingExport(true);
      const token = localStorage.getItem('token');

      let allEtudiants = [];
      try {
        const response = await axios.get('    https://vmi1977988.contaboserver.net/api2/partners/etudiants', {
          headers: { Authorization: `Bearer ${token}` }
        });
        allEtudiants = response.data;
      } catch (err) {
        if (err.response?.status === 404) {
          const fallbackRes = await axios.get('    https://vmi1977988.contaboserver.net/api2/partnersetudiants', {
            headers: { Authorization: `Bearer ${token}` }
          });
          allEtudiants = fallbackRes.data;
        } else {
          throw err;
        }
      }

      const etudiantsAExporter = allEtudiants.filter(e => e.anneeScolaire === exportAnneeScolaire);

      if (etudiantsAExporter.length === 0) {
        alert("Aucun étudiant trouvé pour cette année scolaire.");
        setLoadingExport(false);
        return;
      }

      // Transformer les données pour l'export
      const donneesExport = etudiantsAExporter.map((etudiant, index) => ({
        'N°': index + 1,
        'Code Étudiant': etudiant.codeEtudiant || 'N/A',
        'Nom': etudiant.nomDeFamille || 'N/A',
        'Prénom': etudiant.prenom || 'N/A',
        'Genre': etudiant.genre || 'N/A',
        'Date de Naissance': etudiant.dateNaissance ? new Date(etudiant.dateNaissance).toLocaleDateString('fr-FR') : 'N/A',
        'Nationalité': etudiant.pays || 'N/A',
        'Ville': etudiant.ville || 'N/A',
        'Quartier': etudiant.quartier || 'N/A',
        'Double Compétence IT': etudiant.doubleCompetenceIT ? 'Oui' : 'Non',
        'Filière 2': etudiant.filiere2 || 'N/A',
        'Spécialité 2': etudiant.specialite2 || 'N/A',
        'Option 2': etudiant.option2 || 'N/A',
        'CIN / Passeport': etudiant.cin || 'N/A',
        'Code Massar': etudiant.codeMassar || 'N/A',
        'Email': etudiant.email || 'N/A',
        'Téléphone': etudiant.telephone || 'N/A',
        'Filière': etudiant.filiere || 'N/A',
        'Lieu de Formation': etudiant.lieuFormation || 'N/A',
        'Niveau': etudiant.niveau || 'N/A',
        'Option': etudiant.option || 'N/A',
        'Spécialité': etudiant.specialite || 'N/A',
        'Type Diplôme': etudiant.typeDiplome || 'N/A',
        'Classe': etudiant.cours ? etudiant.cours.join(', ') : 'N/A',
        'Situation': etudiant.situation || 'N/A',
        'Statut': etudiant.actif ? 'Actif' : 'Inactif'
      }));

      const ws = XLSX.utils.json_to_sheet(donneesExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, `Étudiants_${exportAnneeScolaire.replace('/', '-')}`);

      // Ajuster la largeur des colonnes
      ws['!cols'] = Array(20).fill({ wch: 15 });

      const fileName = `Etudiants_Partenaire_${exportAnneeScolaire.replace('/', '-')}_${new Date().toISOString().split('T')[0]}.xlsx`;
      XLSX.writeFile(wb, fileName);

      setShowExportModal(false);
      setExportAnneeScolaire('');
      alert(`Export réussi ! ${etudiantsAExporter.length} étudiants exportés.`);
    } catch (error) {
      console.error('Erreur export:', error);
      alert('Erreur lors de l\'export.');
    } finally {
      setLoadingExport(false);
    }
  };

  // Pagination
  const indexDernierEtudiant = pageActuelle * etudiantsParPage;
  const indexPremierEtudiant = indexDernierEtudiant - etudiantsParPage;
  const etudiantsActuels = etudiantsFiltres.slice(indexPremierEtudiant, indexDernierEtudiant);
  const totalPages = Math.ceil(etudiantsFiltres.length / etudiantsParPage);

  const changerPage = (numerePage) => {
    setPageActuelle(numerePage);
  };

  // Obtenir tous les cours uniques pour le filtre
  const coursUniques = [...new Set(etudiants.flatMap(e => e.cours || []))];

  if (loading) {
    return <div className="loading">Chargement des étudiants...</div>;
  }

  return (
    <div className="liste-etudiants-container" style={{
      background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 25%, #f3e8ff 100%)'
    }}>


      <div className="header" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        <h2 style={{ width: '100%', textAlign: 'center' }}>Liste des Étudiants</h2>
        <button
          onClick={handleLogout}
          className="btn-logout"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 16px',
            backgroundColor: '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#b91c1c';
            e.target.style.transform = 'translateY(-1px)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#dc2626';
            e.target.style.transform = 'translateY(0)';
          }}
          title="Se déconnecter"
        >
          <LogOut size={16} />
          Déconnexion
        </button>
        <div className="header-actions">
          <div className="stats">
            Total: {etudiantsFiltres.length} étudiants
          </div>

          <div className="vue-toggle">
            <button
              onClick={() => setVueMode('tableau')}
              className={`btn-vue ${vueMode === 'tableau' ? 'active' : ''}`}
            >
              Tableau
            </button>
            <button
              onClick={() => setVueMode('carte')}
              className={`btn-vue ${vueMode === 'carte' ? 'active' : ''}`}
            >
              Cartes
            </button>
          </div>

          <button onClick={openModal} className="btn-ajouter-etudiant">
            Ajouter un étudiant
          </button>
          <button onClick={() => setShowExportModal(true)} className="btn-export-excel">
            📊 Exporter Excel
          </button>
        </div>
      </div>

      {/* Section des filtres */}
      <div className="filtres-section">
        <div className="filtres-row">
          <div className="filtre-groupe">
            <label>Rechercher:</label>
            <input
              type="text"
              placeholder="Nom, téléphone, CIN, code..."
              value={recherche}
              onChange={(e) => setRecherche(e.target.value)}
              className="input-recherche"
            />
          </div>

          <div className="filtre-groupe">
            <label>Genre:</label>
            <select
              value={filtreGenre}
              onChange={(e) => setFiltreGenre(e.target.value)}
              className="select-filtre"
            >
              <option value="">Tous</option>
              <option value="Homme">Homme</option>
              <option value="Femme">Femme</option>
            </select>
          </div>

          <div className="filtre-groupe">
            <label>Classe:</label>
            <select
              value={filtreCours}
              onChange={(e) => setFiltreCours(e.target.value)}
              className="select-filtre"
            >
              <option value="">Tous les classes</option>
              {coursUniques.map(cours => (
                <option key={cours} value={cours}>{cours}</option>
              ))}
            </select>
          </div>

          <div className="filtre-groupe">
            <label>Statut:</label>
            <select
              value={filtreActif}
              onChange={(e) => setFiltreActif(e.target.value)}
              className="select-filtre"
            >
              <option value="">Tous</option>
              <option value="true">Actif</option>
              <option value="false">Inactif</option>
            </select>
          </div>

          <button onClick={viderFiltres} className="btn-vider-filtres">
            Vider les filtres
          </button>
        </div>
      </div>

      {/* Vue Tableau ou Cartes */}
      {vueMode === 'tableau' ? (
        // VUE TABLEAU
        <div className="tableau-container">
          <table className="tableau-etudiants">
            <thead>
              <tr>
                <th>Nom Complet</th>
                <th>Genre</th>
                <th>Date de Naissance</th>
                <th>Téléphone</th>
                <th>Email</th>
                <th>Validation Pédagogique</th>
                <th>Prix Total</th>
                <th>N° Reçu</th>
                <th>Classe</th>
                <th>Lieu de Formation</th>
                {/* Remplacer la colonne Commercial par Partner */}
                <th>Partner</th>
                <th>Statut</th>
                <th>Image</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {etudiantsActuels.length === 0 ? (
                <tr>
                  <td colSpan="14" className="aucun-resultat">
                    Aucun étudiant trouvé
                  </td>
                </tr>
              ) : (
                etudiantsActuels.map((e) => (
                  <tr key={e._id}>
                    <td className="nom-colonne">{getNomComplet(e)}</td>
                    <td>{e.genre}</td>
                    <td>{formatDate(e.dateNaissance)}</td>
                    <td>{e.telephone}</td>
                    <td>{e.email}</td>
                    <td className="validation-colonne">
                      <span className={`validation-badge ${e.validationPedagogique?.statut === 'Validé' ? 'valide' :
                        e.validationPedagogique?.statut === 'Pas Validé' ? 'pas-valide' :
                          e.validationPedagogique?.statut === 'En cours' ? 'en-cours' : 'en-attente'
                        }`}>
                        {e.validationPedagogique?.statut || 'En attente'}
                      </span>
                      {e.validationPedagogique?.commentaire && (
                        <div className="validation-commentaire">
                          {e.validationPedagogique.commentaire.substring(0, 30)}...
                        </div>
                      )}
                    </td>
                    <td className="prix-colonne">
                      {e.prixTotalPartner ? `${e.prixTotalPartner} DH` : 'N/A'}                    </td>
                    <td className="recu-colonne">
                      <strong style={{ color: '#2563eb' }}>{e.numRecu || 'N/A'}</strong>
                    </td>
                    <td className="cours-colonne">
                      {e.cours ? e.cours.join(', ') : 'Aucun'}
                    </td>
                    <td className="lieu-formation-colonne">
                      {e.lieuFormation || 'N/A'}
                    </td>
                    <td className="partner-colonne">
                      <span>{e.nomPartner?.nomPartner || 'N/A'}</span>
                    </td>
                    <td className="statut-colonne">
                      <div className="toggle-switch-container">
                        <span className={`statut-text ${e.actif ? 'actif' : 'inactif'}`}>
                          {e.actif ? 'Actif' : 'Inactif'}
                        </span>
                        <label className="toggle-switch">
                          <input
                            type="checkbox"
                            checked={e.actif}
                            onChange={() => handleToggleActif(e._id)}
                          />
                          <span className="slider"></span>
                        </label>
                      </div>
                    </td>
                    <td className="image-colonne">
                      {e.image ? (
                        <img
                          src={`     https://vmi1977988.contaboserver.net${e.image}`}
                          alt="etudiant"
                          className="image-etudiant"
                        />
                      ) : (
                        <div className="pas-image">N/A</div>
                      )}
                    </td>
                    <td className="actions-colonne">
                      <button
                        onClick={() => handleView(e)}
                        className="btn-voir"
                      >
                        <Eye size={16} />
                      </button>
                      <button
                        onClick={() => handleEdit(e)}
                        className="btn-modifier"
                      >
                        <Edit size={16} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      ) : (
        // VUE CARTES
        <div className="cartes-container">
          {etudiantsActuels.length === 0 ? (
            <div className="aucun-resultat-cartes">
              Aucun étudiant trouvé
            </div>
          ) : (
            <div className="cartes-grid">
              {etudiantsActuels.map((e) => (
                <div key={e._id} className="carte-etudiant">
                  <div className="carte-header">
                    <div className="carte-image">
                      {e.image ? (
                        <img
                          src={`     https://vmi1977988.contaboserver.net${e.image}`}
                          alt="etudiant"
                          className="carte-photo"
                        />
                      ) : (
                        <div className="carte-placeholder">
                          <User size={24} />
                        </div>
                      )}
                    </div>
                    <div className="carte-statut">
                      <span className={`statut-badge ${e.actif ? 'actif' : 'inactif'}`}>
                        {e.actif ? <CheckCircle size={16} /> : <XCircle size={16} />}
                      </span>
                    </div>
                  </div>

                  <div className="carte-content">
                    <h3 className="carte-nom">{getNomComplet(e)}</h3>
                    <div className="carte-info">
                      <div className="carte-detail">
                        <span className="carte-label">Année Scolaire:</span>
                        <span>
                          <Calendar size={16} className="inline mr-1" />
                          {e.anneeScolaire || 'N/A'}
                        </span>
                      </div>
                      <div className="carte-detail">
                        <span className="carte-label">Genre:</span>
                        <span>
                          <User size={16} className="inline mr-1" /> {e.genre}
                        </span>
                      </div>
                      <div className="carte-detail">
                        <span className="carte-label">Âge:</span>
                        <span>{calculerAge(e.dateNaissance)} ans</span>
                      </div>
                      <div className="carte-detail">
                        <span className="carte-label">Téléphone:</span>
                        <span>
                          <Phone size={16} className="inline mr-1" /> {e.telephone}
                        </span>
                      </div>
                      <div className="carte-detail">
                        <span className="carte-label">Email:</span>
                        <span>{e.email}</span>
                      </div>
                      {e.cin && (
                        <div className="carte-detail">
                          <span className="carte-label">CIN:</span>
                          <span>
                            <IdCard size={16} className="inline mr-1" /> {e.cin}
                          </span>
                        </div>
                      )}
                      {e.passport && (
                        <div className="carte-detail">
                          <span className="carte-label">Passeport:</span>
                          <span className="carte-value">{e.passport}</span>
                        </div>
                      )}
                      {e.lieuNaissance && (
                        <div className="carte-detail">
                          <span className="carte-label">Lieu de naissance:</span>
                          <span className="carte-value">
                            <MapPin size={16} className="inline mr-1" />
                            {e.lieuNaissance}
                          </span>
                        </div>
                      )}
                      {e.lieuFormation && (
                        <div className="carte-detail">
                          <span className="carte-label">Lieu de formation:</span>
                          <span className="carte-value">
                            <MapPin size={16} className="inline mr-1" />
                            {e.lieuFormation}
                          </span>
                        </div>
                      )}
                      {e.pays && (
                        <div className="carte-detail">
                          <span className="carte-label">Pays:</span>
                          <span className="carte-value">{e.pays}</span>
                        </div>
                      )}
                      {e.validationPedagogique && (
                        <div className="carte-detail">
                          <span className="carte-label">Validation:</span>
                          <span className={`validation-badge-card ${e.validationPedagogique?.statut === 'Validé' ? 'valide' :
                            e.validationPedagogique?.statut === 'Pas Validé' ? 'pas-valide' :
                              e.validationPedagogique?.statut === 'En cours' ? 'en-cours' : 'en-attente'
                            }`}>
                            {e.validationPedagogique?.statut || 'En attente'}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="carte-actions">
                    <button
                      onClick={() => handleView(e)}
                      className="btn-carte btn-voir"
                      title="Voir détails"
                    >
                      <Eye size={16} />
                    </button>
                    <button
                      onClick={() => handleEdit(e)}
                      className="btn-carte btn-modifier"
                      title="Modifier"
                    >
                      <Edit size={16} />
                    </button>
                    <button
                      onClick={() => handleToggleActif(e._id)}
                      className="btn-carte btn-toggle"
                      title={e.actif ? 'Désactiver' : 'Activer'}
                    >
                      <RotateCcw size={16} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => changerPage(pageActuelle - 1)}
            disabled={pageActuelle === 1}
            className="btn-pagination"
          >
            Précédent
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => changerPage(i + 1)}
              className={`btn-pagination ${pageActuelle === i + 1 ? 'active' : ''}`}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() => changerPage(pageActuelle + 1)}
            disabled={pageActuelle === totalPages}
            className="btn-pagination"
          >
            Suivant
          </button>
        </div>
      )}

      {/* Modal d'ajout d'étudiant */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Ajouter un étudiant</h3>
              <button className="btn-fermer-modal" onClick={closeModal}>×</button>
            </div>

            <form onSubmit={handleSubmitAjout} className="form-ajout-etudiant">
              {/* Section Informations personnelles */}
              <div className="form-section">
                <h4><User size={20} className="inline mr-2" />Informations personnelles</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Prénom *</label>
                    <input
                      type="text"
                      name="prenom"
                      placeholder="Prénom"
                      value={formAjout.prenom}
                      onChange={handleChangeAjout}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Nom de Famille *</label>
                    <input
                      type="text"
                      name="nomDeFamille"
                      placeholder="Nom de famille"
                      value={formAjout.nomDeFamille}
                      onChange={handleChangeAjout}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Genre *</label>
                    <select name="genre" value={formAjout.genre} onChange={handleChangeAjout}>
                      <option value="Homme">Homme</option>
                      <option value="Femme">Femme</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Date de Naissance *</label>
                    <input
                      type="date"
                      name="dateNaissance"
                      value={formAjout.dateNaissance}
                      onChange={handleChangeAjout}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Téléphone *</label>
                    <input
                      type="text"
                      name="telephone"
                      placeholder="Téléphone"
                      value={formAjout.telephone}
                      onChange={handleChangeAjout}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Téléphone Responsable</label>
                    <input
                      type="text"
                      name="telephoneResponsable"
                      placeholder="Téléphone du responsable"
                      value={formAjout.telephoneResponsable}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formAjout.email}
                      onChange={handleChangeAjout}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>CIN</label>
                    <input
                      type="text"
                      name="cin"
                      placeholder="Numéro CIN"
                      value={formAjout.cin}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Passeport</label>
                    <input
                      type="text"
                      name="passeport"
                      placeholder="Numéro passeport"
                      value={formAjout.passeport}
                      onChange={handleChangeAjout}
                    />
                  </div>
                  <div className="form-group">
                    <label>Lieu de Formation</label>
                    <select
                      name="lieuFormation"
                      value={formAjout.lieuFormation}
                      onChange={handleChangeAjout}
                    >
                      <option value="">Sélectionner le lieu de formation...</option>
                      {LIEUX_FORMATION.map((lieu) => (
                        <option key={lieu} value={lieu}>{lieu}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Lieu de Naissance</label>
                    <input
                      type="text"
                      name="lieuNaissance"
                      placeholder="Lieu de naissance"
                      value={formAjout.lieuNaissance}
                      onChange={handleChangeAjout}
                    />
                  </div>
                  <div className="form-group">
                    <label>Pays *</label>
                    <select
                      name="pays"
                      value={formAjout.pays}
                      onChange={handleChangeAjout}
                      required
                    >
                      <option value="">Sélectionner le pays...</option>
                      {PAYS_LIST.map((pays) => (
                        <option key={pays} value={pays}>{pays}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Ville</label>
                    <input
                      type="text"
                      name="ville"
                      placeholder="Ville (ex: Casablanca)"
                      value={formAjout.ville || ''}
                      onChange={handleChangeAjout}
                    />
                  </div>
                  <div className="form-group">
                    <label>Quartier</label>
                    <input
                      type="text"
                      name="quartier"
                      placeholder="Quartier (ex: Maarif)"
                      value={formAjout.quartier || ''}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Mot de Passe *</label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type={showPasswordAjout ? "text" : "password"}
                      name="motDePasse"
                      placeholder="Mot de passe"
                      value={formAjout.motDePasse}
                      onChange={handleChangeAjout}
                      required
                      minLength="6"
                      style={{ paddingRight: '35px' }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPasswordAjout(!showPasswordAjout)}
                      style={{
                        position: 'absolute',
                        right: '8px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#666',
                        padding: '0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {showPasswordAjout ? <EyeOff size={16} /> : <Eye size={16} />}
                    </button>
                  </div>
                </div>
              </div>

              {/* Section Formation Intelligente */}
              <div className="form-section">
                <h4><GraduationCap size={20} className="inline mr-2" />Formation Intelligente</h4>

                {/* Nouveau champ année scolaire */}
                <div className="form-row">
                  <div className="form-group">
                    <label>Année Scolaire *</label>
                    <input
                      type="text"
                      name="anneeScolaire"
                      placeholder="YYYY/YYYY (ex: 2025/2026)"
                      value={formAjout.anneeScolaire}
                      onChange={handleChangeAjout}
                      required
                      pattern="^\d{4}/\d{4}$"
                      title="Format: YYYY/YYYY (ex: 2025/2026)"
                    />
                    <small style={{ color: '#666', fontSize: '12px' }}>
                      Format obligatoire: YYYY/YYYY (ex: 2025/2026)
                    </small>
                  </div>
                </div>
                <div className="form-group">
                  <label>Niveau de Formation</label>
                  <select
                    name="niveauFormation"
                    value={formAjout.niveauFormation}
                    onChange={handleChangeAjout}
                  >
                    <option value="">Sélectionner...</option>
                    <option value="FI">FI</option>
                    <option value="TA">TA</option>
                    <option value="Executive">Executive</option>
                  </select>
                </div>
                <FormationSelector
                  form={formAjout}
                  onChange={handleFormationChangeAjout}
                />

                <div className="form-row">

                  <div className="form-group">
                    <label>Type de Diplôme</label>
                    <input
                      type="text"
                      name="typeDiplome"
                      placeholder="Type de diplôme"
                      value={formAjout.typeDiplome}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Classes</label>
                  {coursFiltres.length > 0 ? (
                    <div className="cours-selection-container">
                      {coursFiltres.map((cours) => (
                        <div
                          key={cours._id}
                          className={`cours-chip ${formAjout.cours.includes(cours.nom) ? 'selected' : ''}`}
                          onClick={() => handleSelectCoursAjout(cours.nom)}
                        >
                          <span className="cours-nom">{cours.nom}</span>
                          {formAjout.cours.includes(cours.nom) && (
                            <span className="cours-check">✓</span>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p style={{ color: '#666', textAlign: 'center' }}>
                      Sélectionnez votre formation d'abord
                    </p>
                  )}
                </div>
              </div>

              {/* Section Diplôme d'accès */}
              <div className="form-section">
                <h4><Award size={20} className="inline mr-2" />Diplôme d'accès</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Diplôme d'Accès</label>
                    <input
                      type="text"
                      name="diplomeAcces"
                      placeholder="Diplôme d'accès"
                      value={formAjout.diplomeAcces}
                      onChange={handleChangeAjout}
                    />
                  </div>
                  <div className="form-group">
                    <label>Spécialité Diplôme d'Accès</label>
                    <input
                      type="text"
                      name="specialiteDiplomeAcces"
                      placeholder="Spécialité du diplôme d'accès"
                      value={formAjout.specialiteDiplomeAcces}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Mention</label>
                    <input
                      type="text"
                      name="mention"
                      placeholder="Mention"
                      value={formAjout.mention}
                      onChange={handleChangeAjout}
                    />
                  </div>
                  <div className="form-group">
                    <label>Lieu d'Obtention du Diplôme</label>
                    <input
                      type="text"
                      name="lieuObtentionDiplome"
                      placeholder="Lieu d'obtention"
                      value={formAjout.lieuObtentionDiplome}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Série Baccalauréat</label>
                    <input
                      type="text"
                      name="serieBaccalaureat"
                      placeholder="Série du baccalauréat"
                      value={formAjout.serieBaccalaureat}
                      onChange={handleChangeAjout}
                    />
                  </div>
                  <div className="form-group">
                    <label>Année Baccalauréat</label>
                    <input
                      type="number"
                      name="anneeBaccalaureat"
                      placeholder="Année du baccalauréat"
                      value={formAjout.anneeBaccalaureat}
                      onChange={handleChangeAjout}
                      min="1900"
                      max={new Date().getFullYear()}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Code Baccalauréat</label>
                    <input
                      type="text"
                      name="codeBaccalaureat"
                      placeholder="Code baccalauréat"
                      value={formAjout.codeBaccalaureat}
                      onChange={handleChangeAjout}
                    />
                  </div>
                  <div className="form-group">
                    <label>Première Année d'Inscription</label>
                    <input
                      type="number"
                      name="premiereAnneeInscription"
                      placeholder="Première année d'inscription"
                      value={formAjout.premiereAnneeInscription}
                      onChange={handleChangeAjout}
                      min="1900"
                      max={new Date().getFullYear() + 10}
                    />
                  </div>
                  <div className="form-group">
                    <label>Source d'Inscription</label>
                    <select
                      name="sourceInscription"
                      value={formAjout.sourceInscription}
                      onChange={handleChangeAjout}
                    >
                      <option value="">Sélectionner la source...</option>
                      {SOURCES_INSCRIPTION.map((src) => (
                        <option key={src} value={src}>{src}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>Date d'Inscription</label>
                  <input
                    type="date"
                    name="dateInscription"
                    value={formAjout.dateInscription}
                    onChange={handleChangeAjout}
                  />
                </div>
              </div>
              {/* Section Prix pour Partner */}
              <div className="form-section">
                <h4><CreditCard size={20} className="inline mr-2" />Tarification</h4>
                <div style={{
                  padding: '15px',
                  background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                  border: '2px solid #0284c7',
                  borderRadius: '12px',
                  marginBottom: '20px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Shield size={24} style={{ color: '#0284c7' }} />
                    <div>
                      <h5 style={{ margin: 0, color: '#075985', fontWeight: '600' }}>
                        Compte Partner Actif
                      </h5>
                      <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#64748b' }}>
                        Les étudiants seront automatiquement associés à votre organisation
                      </p>
                    </div>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Prix Total Partner *</label>
                    <input
                      type="number"
                      name="prixTotalPartner"
                      placeholder="Prix convenu pour cet étudiant"
                      value={formAjout.prixTotalPartner}
                      onChange={handleChangeAjout}
                      required
                      min="1"
                      step="1"
                    />
                    <small style={{ color: '#666', fontSize: '12px' }}>
                      Entrez le montant convenu avec votre organisation
                    </small>
                  </div>
                  <div className="form-group">
                    <label>Pourcentage Bourse (%)</label>
                    <input
                      type="number"
                      name="pourcentageBourse"
                      placeholder="Si applicable"
                      value={formAjout.pourcentageBourse}
                      onChange={handleChangeAjout}
                      min="0"
                      max="100"
                    />
                  </div>
                </div>
              </div>


              {/* Section Inscription et Paiement */}
              <div className="form-section">
                <h4><CreditCard size={20} className="inline mr-2" />Inscription et Paiement</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Code Étudiant</label>
                    <input
                      type="text"
                      name="codeEtudiant"
                      placeholder="Code étudiant (généré automatiquement)"
                      value={formAjout.codeEtudiant}
                      onChange={handleChangeAjout}
                      readOnly
                      style={{ backgroundColor: '#f0f0f0' }}
                    />
                    <small style={{ color: '#666', fontSize: '12px' }}>
                      Le code sera généré automatiquement basé sur la formation et le nom
                    </small>
                  </div>

                </div>


                <div className="form-row">
                  <div className="form-group">
                    <label>Mode de Paiement</label>
                    <select
                      name="modePaiement"
                      value={formAjout.modePaiement}
                      onChange={handleChangeAjout}
                    >
                      <option value="semestriel">Semestriel</option>
                      <option value="trimestriel">Trimestriel</option>
                      <option value="mensuel">Mensuel</option>
                      <option value="annuel">Annuel</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Type de Paiement</label>
                    <input
                      type="text"
                      name="typePaiement"
                      placeholder="Type de paiement"
                      value={formAjout.typePaiement}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Image</label>
                  <input
                    type="file"
                    name="image"
                    accept="image/*"
                    onChange={handleImageChangeAjout}
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Situation</label>
                    <input
                      type="text"
                      name="situation"
                      placeholder="Situation"
                      value={formAjout.situation}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Date et Règlement</label>
                  <input
                    type="text"
                    name="dateEtReglement"
                    placeholder="Date et règlement"
                    value={formAjout.dateEtReglement}
                    onChange={handleChangeAjout}
                  />
                </div>

                <div className="form-group">
                  <label style={{ fontWeight: 'bold', color: '#1e3a8a' }}>Numéro de Reçu *</label>
                  <input
                    type="text"
                    name="numRecu"
                    placeholder="Numéro de reçu obligatoire"
                    value={formAjout.numRecu || ''}
                    onChange={handleChangeAjout}
                    required
                  />
                </div>
              </div>

              {/* Section Autres informations */}
              <div className="form-section">
                <h4><FileText size={20} className="inline mr-2" />Autres informations</h4>

                <div className="form-group">
                  <label>Image</label>
                  <input
                    type="file"
                    name="image"
                    accept="image/*"
                    onChange={handleImageChangeAjout}
                  />
                </div>

                {/* Section Documents */}
                <div className="documents-section">
                  <h5>Documents avec Commentaires</h5>

                  {/* CIN Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Document CIN</label>
                      <input
                        type="file"
                        name="documentCin"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire CIN</label>
                      <input
                        type="text"
                        name="commentaireCin"
                        placeholder="Commentaire pour le document CIN"
                        value={formAjout.commentaireCin}
                        onChange={handleChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Bac Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Document Bac</label>
                      <input
                        type="file"
                        name="documentBacCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Bac</label>
                      <input
                        type="text"
                        name="commentaireBacCommentaire"
                        placeholder="Commentaire pour le document Bac"
                        value={formAjout.commentaireBacCommentaire}
                        onChange={handleChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Relevé Notes Bac */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Relevé Notes Bac</label>
                      <input
                        type="file"
                        name="documentReleveNoteBac"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Relevé Notes Bac</label>
                      <input
                        type="text"
                        name="commentaireReleveNoteBac"
                        placeholder="Commentaire pour le relevé notes Bac"
                        value={formAjout.commentaireReleveNoteBac}
                        onChange={handleChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Passeport Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Document Passeport</label>
                      <input
                        type="file"
                        name="documentPasseport"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Passeport</label>
                      <input
                        type="text"
                        name="commentairePasseport"
                        placeholder="Commentaire pour le passeport"
                        value={formAjout.commentairePasseport}
                        onChange={handleChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Diplôme Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Document Diplôme</label>
                      <input
                        type="file"
                        name="documentDiplomeCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Diplôme</label>
                      <input
                        type="text"
                        name="commentaireDiplomeCommentaire"
                        placeholder="Commentaire pour le diplôme"
                        value={formAjout.commentaireDiplomeCommentaire}
                        onChange={handleChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Attestation Réussite Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Attestation Réussite</label>
                      <input
                        type="file"
                        name="documentAttestationReussiteCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Attestation Réussite</label>
                      <input
                        type="text"
                        name="commentaireAttestationReussiteCommentaire"
                        placeholder="Commentaire pour l'attestation de réussite"
                        value={formAjout.commentaireAttestationReussiteCommentaire}
                        onChange={handleChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Relevé Notes Formation Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Relevé Notes Formation</label>
                      <input
                        type="file"
                        name="documentReleveNotesFormationCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Relevé Notes Formation</label>
                      <input
                        type="text"
                        name="commentaireReleveNotesFormationCommentaire"
                        placeholder="Commentaire pour le relevé notes formation"
                        value={formAjout.commentaireReleveNotesFormationCommentaire}
                        onChange={handleChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Bac ou Attestation Bac Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Bac ou Attestation Bac</label>
                      <input
                        type="file"
                        name="documentBacOuAttestationBacCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Bac ou Attestation Bac</label>
                      <input
                        type="text"
                        name="commentaireBacOuAttestationBacCommentaire"
                        placeholder="Commentaire pour bac ou attestation bac"
                        value={formAjout.commentaireBacOuAttestationBacCommentaire}
                        onChange={handleChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Authentification Bac Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Authentification Bac</label>
                      <input
                        type="file"
                        name="documentAuthentificationBac"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Authentification Bac</label>
                      <input
                        type="text"
                        name="commentaireAuthentificationBac"
                        placeholder="Commentaire pour l'authentification bac"
                        value={formAjout.commentaireAuthentificationBac}
                        onChange={handleChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Authentication Diplôme Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Authentication Diplôme</label>
                      <input
                        type="file"
                        name="documentAuthenticationDiplome"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Authentication Diplôme</label>
                      <input
                        type="text"
                        name="commentaireAuthenticationDiplome"
                        placeholder="Commentaire pour l'authentication diplôme"
                        value={formAjout.commentaireAuthenticationDiplome}
                        onChange={handleChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Engagement Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Engagement</label>
                      <input
                        type="file"
                        name="documentEngagementCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Engagement</label>
                      <input
                        type="text"
                        name="commentaireEngagementCommentaire"
                        placeholder="Commentaire pour l'engagement"
                        value={formAjout.commentaireEngagementCommentaire}
                        onChange={handleChangeAjout}
                      />
                    </div>
                  </div>
                </div>

                <div className="checkbox-grid">
                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="actif"
                        checked={formAjout.actif}
                        onChange={handleChangeAjout}
                      />
                      Étudiant actif
                    </label>
                  </div>

                  <div className="form-group">
                    <label>Payé *</label>
                    <select
                      name="paye"
                      value={formAjout.paye}
                      onChange={handleChangeAjout}
                      required
                      style={{ border: formAjout.paye === '' ? '1px solid #dc2626' : '1px solid #d1d5db' }}
                    >
                      <option value="">-- Sélectionner statut --</option>
                      <option value="true">Oui (Payé)</option>
                      <option value="false">Non (Non Payé)</option>
                    </select>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="nouvelleInscription"
                        checked={formAjout.nouvelleInscription}
                        onChange={handleChangeAjout}
                      />
                      Nouvelle inscription
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="handicape"
                        checked={formAjout.handicape}
                        onChange={handleChangeAjout}
                      />
                      Handicapé
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="resident"
                        checked={formAjout.resident}
                        onChange={handleChangeAjout}
                      />
                      Résident
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="fonctionnaire"
                        checked={formAjout.fonctionnaire}
                        onChange={handleChangeAjout}
                      />
                      Fonctionnaire
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="mobilite"
                        checked={formAjout.mobilite}
                        onChange={handleChangeAjout}
                      />
                      Mobilité
                    </label>
                  </div>
                </div>
              </div>

              {messageAjout && (
                <div className={`message-ajout ${messageAjout.includes('✅') ? 'success' : 'error'}`}>
                  {messageAjout}
                </div>
              )}

              <div className="modal-actions">
                <button type="button" onClick={closeModal} className="btn-annuler">
                  Annuler
                </button>
                <button type="submit" disabled={loadingAjout} className="btn-enregistrer">
                  {loadingAjout ? 'Enregistrement...' : 'Enregistrer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de modification d'étudiant */}
      {showEditModal && etudiantAModifier && (
        <div className="modal-overlay" onClick={closeEditModal}>
          <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Modifier l'étudiant</h3>
              <button className="btn-fermer-modal" onClick={closeEditModal}>×</button>
            </div>

            <form onSubmit={handleSubmitModifier} className="form-ajout-etudiant">
              {/* Section Informations personnelles */}
              <div className="form-section">
                <h4><User size={20} className="inline mr-2" />Informations personnelles</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Prénom *</label>
                    <input
                      type="text"
                      name="prenom"
                      placeholder="Prénom"
                      value={formModifier.prenom}
                      onChange={handleChangeModifier}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Nom de Famille *</label>
                    <input
                      type="text"
                      name="nomDeFamille"
                      placeholder="Nom de famille"
                      value={formModifier.nomDeFamille}
                      onChange={handleChangeModifier}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Genre *</label>
                    <select name="genre" value={formModifier.genre} onChange={handleChangeModifier}>
                      <option value="Homme">Homme</option>
                      <option value="Femme">Femme</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Date de Naissance *</label>
                    <input
                      type="date"
                      name="dateNaissance"
                      value={formModifier.dateNaissance}
                      onChange={handleChangeModifier}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Téléphone *</label>
                    <input
                      type="text"
                      name="telephone"
                      placeholder="Téléphone"
                      value={formModifier.telephone}
                      onChange={handleChangeModifier}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Téléphone Responsable</label>
                    <input
                      type="text"
                      name="telephoneResponsable"
                      placeholder="Téléphone du responsable"
                      value={formModifier.telephoneResponsable}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formModifier.email}
                      onChange={handleChangeModifier}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>CIN</label>
                    <input
                      type="text"
                      name="cin"
                      placeholder="Numéro CIN"
                      value={formModifier.cin}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Passeport</label>
                    <input
                      type="text"
                      name="passeport"
                      placeholder="Numéro passeport"
                      value={formModifier.passeport}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Lieu de Formation</label>
                    <select
                      name="lieuFormation"
                      value={formModifier.lieuFormation}
                      onChange={handleChangeModifier}
                    >
                      <option value="">Sélectionner le lieu de formation...</option>
                      {LIEUX_FORMATION.map((lieu) => (
                        <option key={lieu} value={lieu}>{lieu}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Lieu de Naissance</label>
                    <input
                      type="text"
                      name="lieuNaissance"
                      placeholder="Lieu de naissance"
                      value={formModifier.lieuNaissance}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Pays *</label>
                    <select
                      name="pays"
                      value={formModifier.pays}
                      onChange={handleChangeModifier}
                      required
                    >
                      <option value="">Sélectionner le pays...</option>
                      {PAYS_LIST.map((pays) => (
                        <option key={pays} value={pays}>{pays}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Ville</label>
                    <input
                      type="text"
                      name="ville"
                      placeholder="Ville (ex: Casablanca)"
                      value={formModifier.ville || ''}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Quartier</label>
                    <input
                      type="text"
                      name="quartier"
                      placeholder="Quartier (ex: Maarif)"
                      value={formModifier.quartier || ''}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Nouveau Mot de Passe</label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type={showPasswordModifier ? "text" : "password"}
                      name="motDePasse"
                      placeholder="Laisser vide pour garder l'ancien"
                      value={formModifier.motDePasse}
                      onChange={handleChangeModifier}
                      minLength="6"
                      style={{ paddingRight: '35px' }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPasswordModifier(!showPasswordModifier)}
                      style={{
                        position: 'absolute',
                        right: '8px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#666',
                        padding: '0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {showPasswordModifier ? <EyeOff size={16} /> : <Eye size={16} />}
                    </button>
                  </div>
                  <small style={{ color: '#666', fontSize: '12px' }}>
                    Laisser vide pour conserver le mot de passe actuel
                  </small>
                </div>
              </div>

              {/* Section Formation Intelligente */}
              <div className="form-section">
                <h4><GraduationCap size={20} className="inline mr-2" />Formation Intelligente</h4>

                <div className="form-row">
                  <div className="form-group">
                    <label>Année Scolaire *</label>
                    <input
                      type="text"
                      name="anneeScolaire"
                      placeholder="YYYY/YYYY (ex: 2025/2026)"
                      value={formModifier.anneeScolaire}
                      onChange={handleChangeModifier}
                      required
                      pattern="^\d{4}/\d{4}$"
                      title="Format: YYYY/YYYY (ex: 2025/2026)"
                    />
                    <small style={{ color: '#666', fontSize: '12px' }}>
                      Format obligatoire: YYYY/YYYY (ex: 2025/2026)
                    </small>
                  </div>
                </div>
                <div className="form-group">
                  <label>Niveau de Formation</label>
                  <select
                    name="niveauFormation"
                    value={formModifier.niveauFormation}
                    onChange={handleChangeModifier}
                  >
                    <option value="">Sélectionner...</option>
                    <option value="FI">FI</option>
                    <option value="TA">TA</option>
                    <option value="Executive">Executive</option>
                  </select>
                </div>
                <FormationSelector
                  form={formModifier}
                  onChange={handleFormationChangeModifier}
                />

                <div className="form-row">

                  <div className="form-group">
                    <label>Type de Diplôme</label>
                    <input
                      type="text"
                      name="typeDiplome"
                      placeholder="Type de diplôme"
                      value={formModifier.typeDiplome}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Classes</label>
                  {coursFiltresModif.length > 0 ? (
                    <div className="cours-selection-container">
                      {coursFiltresModif.map((cours) => (
                        <div
                          key={cours._id}
                          className={`cours-chip ${formModifier.cours.includes(cours.nom) ? 'selected' : ''}`}
                          onClick={() => handleSelectCoursModifier(cours.nom)}
                        >
                          <span className="cours-nom">{cours.nom}</span>
                          {formModifier.cours.includes(cours.nom) && (
                            <span className="cours-check">✓</span>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p style={{ color: '#666', textAlign: 'center', padding: '10px' }}>
                      Sélectionnez d'abord votre formation complète
                    </p>
                  )}
                  {formModifier.cours.length > 0 && (
                    <div className="cours-selectionnes">
                      <small>Classes sélectionnées: {formModifier.cours.join(', ')}</small>
                    </div>
                  )}
                </div>
              </div>

              {/* Section Diplôme d'accès */}
              <div className="form-section">
                <h4><Award size={20} className="inline mr-2" />Diplôme d'accès</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Diplôme d'Accès</label>
                    <input
                      type="text"
                      name="diplomeAcces"
                      placeholder="Diplôme d'accès"
                      value={formModifier.diplomeAcces}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Spécialité Diplôme d'Accès</label>
                    <input
                      type="text"
                      name="specialiteDiplomeAcces"
                      placeholder="Spécialité du diplôme d'accès"
                      value={formModifier.specialiteDiplomeAcces}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Mention</label>
                    <input
                      type="text"
                      name="mention"
                      placeholder="Mention"
                      value={formModifier.mention}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Lieu d'Obtention du Diplôme</label>
                    <input
                      type="text"
                      name="lieuObtentionDiplome"
                      placeholder="Lieu d'obtention"
                      value={formModifier.lieuObtentionDiplome}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Série Baccalauréat</label>
                    <input
                      type="text"
                      name="serieBaccalaureat"
                      placeholder="Série du baccalauréat"
                      value={formModifier.serieBaccalaureat}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Année Baccalauréat</label>
                    <input
                      type="number"
                      name="anneeBaccalaureat"
                      placeholder="Année du baccalauréat"
                      value={formModifier.anneeBaccalaureat}
                      onChange={handleChangeModifier}
                      min="1900"
                      max={new Date().getFullYear()}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Code Baccalauréat</label>
                    <input
                      type="text"
                      name="codeBaccalaureat"
                      placeholder="Code baccalauréat"
                      value={formModifier.codeBaccalaureat}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Première Année d'Inscription</label>
                    <input
                      type="number"
                      name="premiereAnneeInscription"
                      placeholder="Première année d'inscription"
                      value={formModifier.premiereAnneeInscription}
                      onChange={handleChangeModifier}
                      min="1900"
                      max={new Date().getFullYear() + 10}
                    />
                  </div>
                  <div className="form-group">
                    <label>Source d'Inscription</label>
                    <select
                      name="sourceInscription"
                      value={formModifier.sourceInscription}
                      onChange={handleChangeModifier}
                    >
                      <option value="">Sélectionner la source...</option>
                      {SOURCES_INSCRIPTION.map((src) => (
                        <option key={src} value={src}>{src}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>Date d'Inscription</label>
                  <input
                    type="date"
                    name="dateInscription"
                    value={formModifier.dateInscription}
                    onChange={handleChangeModifier}
                  />
                </div>
              </div>

              {/* Section Prix pour Partner */}
              <div className="form-section">
                <h4><CreditCard size={20} className="inline mr-2" />Tarification</h4>
                <div style={{
                  padding: '15px',
                  background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                  border: '2px solid #0284c7',
                  borderRadius: '12px',
                  marginBottom: '20px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Shield size={24} style={{ color: '#0284c7' }} />
                    <div>
                      <h5 style={{ margin: 0, color: '#075985', fontWeight: '600' }}>
                        Compte Partner Actif
                      </h5>
                      <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#64748b' }}>
                        Les étudiants seront automatiquement associés à votre organisation
                      </p>
                    </div>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Prix Total Partner *</label>
                    <input
                      type="number"
                      name="prixTotalPartner"
                      placeholder="Prix convenu pour cet étudiant"
                      value={formModifier.prixTotalPartner}
                      onChange={handleChangeModifier}
                      required
                      min="1"
                      step="1"
                    />
                    <small style={{ color: '#666', fontSize: '12px' }}>
                      Entrez le montant convenu avec votre organisation
                    </small>
                  </div>
                  <div className="form-group">
                    <label>Pourcentage Bourse (%)</label>
                    <input
                      type="number"
                      name="pourcentageBourse"
                      placeholder="Si applicable"
                      value={formModifier.pourcentageBourse}
                      onChange={handleChangeModifier}
                      min="0"
                      max="100"
                    />
                  </div>
                </div>
              </div>

              {/* Section Inscription et Paiement */}
              <div className="form-section">
                <h4><CreditCard size={20} className="inline mr-2" />Inscription et Paiement</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Code Étudiant</label>
                    <input
                      type="text"
                      name="codeEtudiant"
                      placeholder="Code étudiant"
                      value={formModifier.codeEtudiant}
                      onChange={handleChangeModifier}
                    />
                  </div>

                </div>

                <div className="form-row">
                  {!formModifier.isPartner && (
                    <div className="form-group">
                      <label>Prix Total</label>
                      <input
                        type="number"
                        name="prixTotal"
                        placeholder="Prix total"
                        value={formModifier.prixTotal}
                        onChange={handleChangeModifier}
                        required={!formModifier.isPartner}
                        min="10000"
                        max="99999"
                        step="1"
                      />
                    </div>
                  )}
                  <div className="form-group">
                    <label>Pourcentage Bourse (%)</label>
                    <input
                      type="number"
                      name="pourcentageBourse"
                      placeholder="Pourcentage de bourse"
                      value={formModifier.pourcentageBourse}
                      onChange={handleChangeModifier}
                      min="0"
                      max="100"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Mode de Paiement</label>
                    <select
                      name="modePaiement"
                      value={formModifier.modePaiement}
                      onChange={handleChangeModifier}
                    >
                      <option value="semestriel">Semestriel</option>
                      <option value="trimestriel">Trimestriel</option>
                      <option value="mensuel">Mensuel</option>
                      <option value="annuel">Annuel</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Type de Paiement</label>
                    <input
                      type="text"
                      name="typePaiement"
                      placeholder="Type de paiement"
                      value={formModifier.typePaiement}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Image</label>
                  <input
                    type="file"
                    name="image"
                    accept="image/*"
                    onChange={handleImageChangeModifier}
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Situation</label>
                    <input
                      type="text"
                      name="situation"
                      placeholder="Situation"
                      value={formModifier.situation}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Date et Règlement</label>
                  <input
                    type="text"
                    name="dateEtReglement"
                    placeholder="Date et règlement"
                    value={formModifier.dateEtReglement}
                    onChange={handleChangeModifier}
                  />
                </div>

                <div className="form-group">
                  <label style={{ fontWeight: 'bold', color: '#1e3a8a' }}>Numéro de Reçu *</label>
                  <input
                    type="text"
                    name="numRecu"
                    placeholder="Numéro de reçu obligatoire"
                    value={formModifier.numRecu || ''}
                    onChange={handleChangeModifier}
                    required
                  />
                </div>
              </div>

              {/* Section Autres informations */}
              <div className="form-section">
                <h4><FileText size={20} className="inline mr-2" />Autres informations</h4>

                <div className="form-group">
                  <label>Image</label>
                  <input
                    type="file"
                    name="image"
                    accept="image/*"
                    onChange={handleImageChangeModifier}
                  />
                </div>

                {/* Section Documents */}
                <div className="documents-section">
                  <h5>Documents avec Commentaires</h5>

                  {/* CIN Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Document CIN</label>
                      <input
                        type="file"
                        name="documentCin"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire CIN</label>
                      <input
                        type="text"
                        name="commentaireCin"
                        placeholder="Commentaire pour le document CIN"
                        value={formModifier.commentaireCin}
                        onChange={handleChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Bac Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Document Bac</label>
                      <input
                        type="file"
                        name="documentBacCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Bac</label>
                      <input
                        type="text"
                        name="commentaireBacCommentaire"
                        placeholder="Commentaire pour le document Bac"
                        value={formModifier.commentaireBacCommentaire}
                        onChange={handleChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Relevé Notes Bac */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Relevé Notes Bac</label>
                      <input
                        type="file"
                        name="documentReleveNoteBac"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Relevé Notes Bac</label>
                      <input
                        type="text"
                        name="commentaireReleveNoteBac"
                        placeholder="Commentaire pour le relevé notes Bac"
                        value={formModifier.commentaireReleveNoteBac}
                        onChange={handleChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Passeport Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Document Passeport</label>
                      <input
                        type="file"
                        name="documentPasseport"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Passeport</label>
                      <input
                        type="text"
                        name="commentairePasseport"
                        placeholder="Commentaire pour le passeport"
                        value={formModifier.commentairePasseport}
                        onChange={handleChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Diplôme Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Document Diplôme</label>
                      <input
                        type="file"
                        name="documentDiplomeCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Diplôme</label>
                      <input
                        type="text"
                        name="commentaireDiplomeCommentaire"
                        placeholder="Commentaire pour le diplôme"
                        value={formModifier.commentaireDiplomeCommentaire}
                        onChange={handleChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Attestation Réussite Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Attestation Réussite</label>
                      <input
                        type="file"
                        name="documentAttestationReussiteCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Attestation Réussite</label>
                      <input
                        type="text"
                        name="commentaireAttestationReussiteCommentaire"
                        placeholder="Commentaire pour l'attestation de réussite"
                        value={formModifier.commentaireAttestationReussiteCommentaire}
                        onChange={handleChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Relevé Notes Formation Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Relevé Notes Formation</label>
                      <input
                        type="file"
                        name="documentReleveNotesFormationCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Relevé Notes Formation</label>
                      <input
                        type="text"
                        name="commentaireReleveNotesFormationCommentaire"
                        placeholder="Commentaire pour le relevé notes formation"
                        value={formModifier.commentaireReleveNotesFormationCommentaire}
                        onChange={handleChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Bac ou Attestation Bac Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Bac ou Attestation Bac</label>
                      <input
                        type="file"
                        name="documentBacOuAttestationBacCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Bac ou Attestation Bac</label>
                      <input
                        type="text"
                        name="commentaireBacOuAttestationBacCommentaire"
                        placeholder="Commentaire pour bac ou attestation bac"
                        value={formModifier.commentaireBacOuAttestationBacCommentaire}
                        onChange={handleChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Authentification Bac Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Authentification Bac</label>
                      <input
                        type="file"
                        name="documentAuthentificationBac"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Authentification Bac</label>
                      <input
                        type="text"
                        name="commentaireAuthentificationBac"
                        placeholder="Commentaire pour l'authentification bac"
                        value={formModifier.commentaireAuthentificationBac}
                        onChange={handleChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Authentication Diplôme Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Authentication Diplôme</label>
                      <input
                        type="file"
                        name="documentAuthenticationDiplome"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Authentication Diplôme</label>
                      <input
                        type="text"
                        name="commentaireAuthenticationDiplome"
                        placeholder="Commentaire pour l'authentication diplôme"
                        value={formModifier.commentaireAuthenticationDiplome}
                        onChange={handleChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Engagement Document */}
                  <div className="document-row">
                    <div className="form-group">
                      <label>Engagement</label>
                      <input
                        type="file"
                        name="documentEngagementCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Engagement</label>
                      <input
                        type="text"
                        name="commentaireEngagementCommentaire"
                        placeholder="Commentaire pour l'engagement"
                        value={formModifier.commentaireEngagementCommentaire}
                        onChange={handleChangeModifier}
                      />
                    </div>
                  </div>
                </div>

                <div className="checkbox-grid">
                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="actif"
                        checked={formModifier.actif}
                        onChange={handleChangeModifier}
                      />
                      Étudiant actif
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="paye"
                        checked={formModifier.paye}
                        onChange={handleChangeModifier}
                      />
                      Payé
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="nouvelleInscription"
                        checked={formModifier.nouvelleInscription}
                        onChange={handleChangeModifier}
                      />
                      Nouvelle inscription
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="handicape"
                        checked={formModifier.handicape}
                        onChange={handleChangeModifier}
                      />
                      Handicapé
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="resident"
                        checked={formModifier.resident}
                        onChange={handleChangeModifier}
                      />
                      Résident
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="fonctionnaire"
                        checked={formModifier.fonctionnaire}
                        onChange={handleChangeModifier}
                      />
                      Fonctionnaire
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="mobilite"
                        checked={formModifier.mobilite}
                        onChange={handleChangeModifier}
                      />
                      Mobilité
                    </label>
                  </div>
                </div>
              </div>

              {messageModifier && (
                <div className={`message-ajout ${messageModifier.includes('✅') ? 'success' : 'error'}`}>
                  {messageModifier}
                </div>
              )}

              <div className="modal-actions">
                <button type="button" onClick={closeEditModal} className="btn-annuler">
                  Annuler
                </button>
                <button type="submit" disabled={loadingModifier} className="btn-enregistrer">
                  {loadingModifier ? 'Enregistrement...' : 'Enregistrer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de visualisation d'étudiant */}
      {showViewModal && etudiantSelectionne && (
        <div className="modal-overlay" onClick={closeViewModal}>
          <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Détails de l'étudiant</h3>
              <button className="btn-fermer-modal" onClick={closeViewModal}>×</button>
            </div>

            <div className="view-content">
              {/* Section Informations personnelles */}
              <div className="view-section">
                <h4><User size={20} className="section-icon" />Informations personnelles</h4>
                <div className="student-header">
                  <div className="student-photo">
                    {etudiantSelectionne.image ? (
                      <img
                        src={`     https://vmi1977988.contaboserver.net${etudiantSelectionne.image}`}
                        alt="étudiant"
                        className="view-photo"
                      />
                    ) : (
                      <div className="view-photo-placeholder">
                        <User size={48} />
                      </div>
                    )}
                  </div>
                  <div className="student-basic-info">
                    <h3 className="student-name">{getNomComplet(etudiantSelectionne)}</h3>
                    <div className="student-status">
                      <span className={`status-badge ${etudiantSelectionne.actif ? 'actif' : 'inactif'}`}>
                        {etudiantSelectionne.actif ? <CheckCircle size={16} /> : <XCircle size={16} />}
                        {etudiantSelectionne.actif ? 'Actif' : 'Inactif'}
                      </span>
                      {etudiantSelectionne.paye && (
                        <span className="status-badge paye">
                          <CheckCircle size={16} />
                          Payé
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="info-grid">
                  <div className="info-row">
                    <span className="info-label">Genre:</span>
                    <span className="info-value">
                      <User size={16} className="info-icon" />
                      {etudiantSelectionne.genre}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Date de naissance:</span>
                    <span className="info-value">
                      <Cake size={16} className="info-icon" />
                      {formatDate(etudiantSelectionne.dateNaissance)} ({calculerAge(etudiantSelectionne.dateNaissance)} ans)
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Téléphone:</span>
                    <span className="info-value">
                      <Phone size={16} className="info-icon" />
                      {etudiantSelectionne.telephone || 'N/A'}
                    </span>
                  </div>
                  {etudiantSelectionne.telephoneResponsable && (
                    <div className="info-row">
                      <span className="info-label">Téléphone Responsable:</span>
                      <span className="info-value">
                        <Phone size={16} className="info-icon" />
                        {etudiantSelectionne.telephoneResponsable}
                      </span>
                    </div>
                  )}
                  <div className="info-row">
                    <span className="info-label">Email:</span>
                    <span className="info-value">{etudiantSelectionne.email}</span>
                  </div>
                  {etudiantSelectionne.cin && (
                    <div className="info-row">
                      <span className="info-label">CIN:</span>
                      <span>
                        <IdCard size={16} className="inline mr-1" /> {etudiantSelectionne.cin}
                      </span>
                    </div>
                  )}
                  {etudiantSelectionne.passeport && (
                    <div className="info-row">
                      <span className="info-label">Passeport:</span>
                      <span className="info-value">{etudiantSelectionne.passeport}</span>
                    </div>
                  )}
                  {etudiantSelectionne.lieuNaissance && (
                    <div className="info-row">
                      <span className="info-label">Lieu de naissance:</span>
                      <span className="info-value">
                        <MapPin size={16} className="info-icon" />
                        {etudiantSelectionne.lieuNaissance}
                      </span>
                    </div>
                  )}
                  {etudiantSelectionne.lieuFormation && (
                    <div className="info-row">
                      <span className="info-label">Lieu de formation:</span>
                      <span className="info-value">
                        <MapPin size={16} className="info-icon" />
                        {etudiantSelectionne.lieuFormation}
                      </span>
                    </div>
                  )}
                  {etudiantSelectionne.pays && (
                    <div className="info-row">
                      <span className="info-label">Pays:</span>
                      <span className="info-value">{etudiantSelectionne.pays}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Section Formation */}
              <div className="view-section">
                <h4><GraduationCap size={20} className="section-icon" />Formation</h4>
                <div className="info-grid">
                  {etudiantSelectionne.anneeScolaire && (
                    <div className="info-row">
                      <span className="info-label">Année Scolaire:</span>
                      <span className="info-value">
                        <Calendar size={16} className="info-icon" />
                        {etudiantSelectionne.anneeScolaire}
                      </span>
                    </div>
                  )}
                  {etudiantSelectionne.niveau && (
                    <div className="info-row">
                      <span className="info-label">Niveau:</span>
                      <span className="info-value">{etudiantSelectionne.niveau}</span>
                    </div>
                  )}
                  {etudiantSelectionne.niveauFormation && (
                    <div className="info-row">
                      <span className="info-label">Niveau de formation:</span>
                      <span className="info-value">{etudiantSelectionne.niveauFormation}</span>
                    </div>
                  )}
                  {etudiantSelectionne.filiere && (
                    <div className="info-row">
                      <span className="info-label">Filière:</span>
                      <span className="info-value">{etudiantSelectionne.filiere}</span>
                    </div>
                  )}
                  {etudiantSelectionne.cycle && (
                    <div className="info-row">
                      <span className="info-label">Cycle:</span>
                      <span className="info-value">{etudiantSelectionne.cycle}</span>
                    </div>
                  )}
                  {etudiantSelectionne.specialiteIngenieur && (
                    <div className="info-row">
                      <span className="info-label">Spécialité d'Ingénieur:</span>
                      <span className="info-value">{etudiantSelectionne.specialiteIngenieur}</span>
                    </div>
                  )}
                  {etudiantSelectionne.optionIngenieur && (
                    <div className="info-row">
                      <span className="info-label">Option d'Ingénieur:</span>
                      <span className="info-value">{etudiantSelectionne.optionIngenieur}</span>
                    </div>
                  )}
                  {etudiantSelectionne.specialiteLicencePro && (
                    <div className="info-row">
                      <span className="info-label">Spécialité Licence Pro:</span>
                      <span className="info-value">{etudiantSelectionne.specialiteLicencePro}</span>
                    </div>
                  )}
                  {etudiantSelectionne.optionLicencePro && (
                    <div className="info-row">
                      <span className="info-label">Option Licence Pro:</span>
                      <span className="info-value">{etudiantSelectionne.optionLicencePro}</span>
                    </div>
                  )}
                  {etudiantSelectionne.specialiteMasterPro && (
                    <div className="info-row">
                      <span className="info-label">Spécialité Master Pro:</span>
                      <span className="info-value">{etudiantSelectionne.specialiteMasterPro}</span>
                    </div>
                  )}
                  {etudiantSelectionne.optionMasterPro && (
                    <div className="info-row">
                      <span className="info-label">Option Master Pro:</span>
                      <span className="info-value">{etudiantSelectionne.optionMasterPro}</span>
                    </div>
                  )}
                  {etudiantSelectionne.option && (
                    <div className="info-row">
                      <span className="info-label">Option:</span>
                      <span className="info-value">{etudiantSelectionne.option}</span>
                    </div>
                  )}
                  {etudiantSelectionne.specialite && (
                    <div className="info-row">
                      <span className="info-label">Spécialité:</span>
                      <span className="info-value">{etudiantSelectionne.specialite}</span>
                    </div>
                  )}
                  {etudiantSelectionne.typeDiplome && (
                    <div className="info-row">
                      <span className="info-label">Type de diplôme:</span>
                      <span className="info-value">{etudiantSelectionne.typeDiplome}</span>
                    </div>
                  )}
                  {etudiantSelectionne.cours && etudiantSelectionne.cours.length > 0 && (
                    <div className="info-row full-width">
                      <span className="info-label">Classe:</span>
                      <div className="cours-tags">
                        {etudiantSelectionne.cours.map((cours, index) => (
                          <span key={index} className="cours-tag">
                            <BookOpen size={14} className="info-icon" />
                            {cours}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Section Diplôme et Parcours */}
              <div className="view-section">
                <h4><Award size={20} className="section-icon" />Diplôme et Parcours antérieur</h4>
                <div className="info-grid">
                  {etudiantSelectionne.diplomeAcces && (
                    <div className="info-row">
                      <span className="info-label">Diplôme d'accès:</span>
                      <span className="info-value">{etudiantSelectionne.diplomeAcces}</span>
                    </div>
                  )}
                  {etudiantSelectionne.specialiteDiplomeAcces && (
                    <div className="info-row">
                      <span className="info-label">Spécialité du diplôme d'accès:</span>
                      <span className="info-value">{etudiantSelectionne.specialiteDiplomeAcces}</span>
                    </div>
                  )}
                  {etudiantSelectionne.mention && (
                    <div className="info-row">
                      <span className="info-label">Mention:</span>
                      <span className="info-value">{etudiantSelectionne.mention}</span>
                    </div>
                  )}
                  {etudiantSelectionne.lieuObtentionDiplome && (
                    <div className="info-row">
                      <span className="info-label">Lieu d'obtention du diplôme:</span>
                      <span className="info-value">
                        <MapPin size={16} className="info-icon" />
                        {etudiantSelectionne.lieuObtentionDiplome}
                      </span>
                    </div>
                  )}
                  {etudiantSelectionne.serieBaccalaureat && (
                    <div className="info-row">
                      <span className="info-label">Série du baccalauréat:</span>
                      <span className="info-value">{etudiantSelectionne.serieBaccalaureat}</span>
                    </div>
                  )}
                  {etudiantSelectionne.anneeBaccalaureat && (
                    <div className="info-row">
                      <span className="info-label">Année du baccalauréat:</span>
                      <span className="info-value">{etudiantSelectionne.anneeBaccalaureat}</span>
                    </div>
                  )}
                  {etudiantSelectionne.codeBaccalaureat && (
                    <div className="info-row">
                      <span className="info-label">Code Baccalauréat:</span>
                      <span className="info-value">{etudiantSelectionne.codeBaccalaureat}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Section Inscription et Paiement */}
              <div className="view-section">
                <h4><CreditCard size={20} className="section-icon" />Inscription et Paiement</h4>
                <div className="info-grid">
                  {etudiantSelectionne.codeEtudiant && (
                    <div className="info-row">
                      <span className="info-label">Code étudiant:</span>
                      <span className="info-value">{etudiantSelectionne.codeEtudiant}</span>
                    </div>
                  )}

                  {etudiantSelectionne.sourceInscription && (
                    <div className="info-row">
                      <span className="info-label">Source d'inscription:</span>
                      <span className="info-value">{etudiantSelectionne.sourceInscription}</span>
                    </div>
                  )}
                  {etudiantSelectionne.prixTotal && (
                    <div className="info-row">
                      <span className="info-label">Prix total:</span>
                      <span className="info-value">{etudiantSelectionne.prixTotalPartner} DH</span>
                    </div>
                  )}
                  {etudiantSelectionne.pourcentageBourse && (
                    <div className="info-row">
                      <span className="info-label">Pourcentage bourse:</span>
                      <span className="info-value">{etudiantSelectionne.pourcentageBourse}%</span>
                    </div>
                  )}
                  {etudiantSelectionne.typePaiement && (
                    <div className="info-row">
                      <span className="info-label">Type de paiement:</span>
                      <span className="info-value">{etudiantSelectionne.typePaiement}</span>
                    </div>
                  )}
                  {etudiantSelectionne.modePaiement && (
                    <div className="info-row">
                      <span className="info-label">Mode de paiement:</span>
                      <span className="info-value">{etudiantSelectionne.modePaiement}</span>
                    </div>
                  )}
                  {etudiantSelectionne.situation && (
                    <div className="info-row">
                      <span className="info-label">Situation:</span>
                      <span className="info-value">{etudiantSelectionne.situation}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Section Étudiant Partenaire */}
              <div className="view-section">
                <h4><Shield size={20} className="section-icon" />Étudiant Partenaire</h4>
                <div className="info-grid">
                  <div className="info-row">
                    <span className="info-label">Statut Partenaire:</span>
                    <span className="info-value">
                      {etudiantSelectionne.isPartner ? (
                        <span className="status-badge partner">
                          <Shield size={16} />
                          Étudiant Partenaire
                        </span>
                      ) : (
                        <span className="status-badge regular">
                          <User size={16} />
                          Étudiant Régulier
                        </span>
                      )}
                    </span>
                  </div>
                  {etudiantSelectionne.isPartner && etudiantSelectionne.nomPartner && (
                    <div className="info-row">
                      <span className="info-label">Nom du Partenaire:</span>
                      <span className="info-value">{getNomPartner(etudiantSelectionne.nomPartner)}</span>
                    </div>
                  )}
                  {etudiantSelectionne.isPartner && etudiantSelectionne.prixTotalPartner && (
                    <div className="info-row">
                      <span className="info-label">Prix Total Partner:</span>
                      <span className="info-value">{etudiantSelectionne.prixTotalPartner} DH</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Section Documents */}
              {(etudiantSelectionne.fichierInscrit || etudiantSelectionne.originalBac ||
                etudiantSelectionne.releveNotes || etudiantSelectionne.copieCni ||
                etudiantSelectionne.passport || etudiantSelectionne.dtsBac2 ||
                etudiantSelectionne.licence) && (
                  <div className="view-section">
                    <h4><FileText size={20} className="section-icon" />Documents</h4>
                    <div className="documents-grid">
                      {etudiantSelectionne.fichierInscrit && (
                        <div className="document-item">
                          <FileText size={16} className="info-icon" />
                          <span>Fichier d'inscription</span>
                          <a href={`     https://vmi1977988.contaboserver.net${etudiantSelectionne.fichierInscrit}`} target="_blank" rel="noopener noreferrer" className="btn-voir-document">
                            Voir
                          </a>
                        </div>
                      )}
                      {etudiantSelectionne.originalBac && (
                        <div className="document-item">
                          <FileText size={16} className="info-icon" />
                          <span>Original Bac</span>
                          <a href={`     https://vmi1977988.contaboserver.net${etudiantSelectionne.originalBac}`} target="_blank" rel="noopener noreferrer" className="btn-voir-document">
                            Voir
                          </a>
                        </div>
                      )}
                      {etudiantSelectionne.releveNotes && (
                        <div className="document-item">
                          <FileText size={16} className="info-icon" />
                          <span>Relevé de notes</span>
                          <a href={`     https://vmi1977988.contaboserver.net${etudiantSelectionne.releveNotes}`} target="_blank" rel="noopener noreferrer" className="btn-voir-document">
                            Voir
                          </a>
                        </div>
                      )}
                      {etudiantSelectionne.copieCni && (
                        <div className="document-item">
                          <IdCard size={16} className="info-icon" />
                          <span>Copie CNI</span>
                          <a href={`     https://vmi1977988.contaboserver.net${etudiantSelectionne.copieCni}`} target="_blank" rel="noopener noreferrer" className="btn-voir-document">
                            Voir
                          </a>
                        </div>
                      )}
                      {etudiantSelectionne.passport && (
                        <div className="document-item">
                          <FileText size={16} className="info-icon" />
                          <span>Passeport</span>
                          <a href={`     https://vmi1977988.contaboserver.net${etudiantSelectionne.passport}`} target="_blank" rel="noopener noreferrer" className="btn-voir-document">
                            Voir
                          </a>
                        </div>
                      )}
                      {etudiantSelectionne.dtsBac2 && (
                        <div className="document-item">
                          <FileText size={16} className="info-icon" />
                          <span>DTS Bac+2</span>
                          <a href={`     https://vmi1977988.contaboserver.net${etudiantSelectionne.dtsBac2}`} target="_blank" rel="noopener noreferrer" className="btn-voir-document">
                            Voir
                          </a>
                        </div>
                      )}
                      {etudiantSelectionne.licence && (
                        <div className="document-item">
                          <GraduationCap size={16} className="info-icon" />
                          <span>Licence</span>
                          <a href={`     https://vmi1977988.contaboserver.net${etudiantSelectionne.licence}`} target="_blank" rel="noopener noreferrer" className="btn-voir-document">
                            Voir
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                )}

              {/* Section Statuts spéciaux */}
              <div className="view-section">
                <h4><Shield size={20} className="section-icon" />Statuts spéciaux</h4>
                <div className="statuts-grid">
                  {etudiantSelectionne.handicape && (
                    <span className="statut-special handicape">♿ Handicapé</span>
                  )}
                  {etudiantSelectionne.resident && (
                    <span className="statut-special resident">🏠 Résident</span>
                  )}
                  {etudiantSelectionne.fonctionnaire && (
                    <span className="statut-special fonctionnaire">👨‍💼 Fonctionnaire</span>
                  )}
                  {etudiantSelectionne.mobilite && (
                    <span className="statut-special mobilite">🌍 Mobilité</span>
                  )}
                </div>
                {!etudiantSelectionne.handicape && !etudiantSelectionne.resident &&
                  !etudiantSelectionne.fonctionnaire && !etudiantSelectionne.mobilite && (
                    <p className="no-statut">Aucun statut spécial</p>
                  )}
              </div>
              {/* Section Validation Pédagogique */}
              <div className="view-section">
                <h4><Shield size={20} className="section-icon" />Validation Pédagogique</h4>
                <div className="info-grid">
                  <div className="info-row">
                    <span className="info-label">Statut:</span>
                    <span className="info-value">
                      <span className={`validation-badge-view ${etudiantSelectionne.validationPedagogique?.statut === 'Validé' ? 'valide' :
                        etudiantSelectionne.validationPedagogique?.statut === 'Pas Validé' ? 'pas-valide' :
                          etudiantSelectionne.validationPedagogique?.statut === 'En cours' ? 'en-cours' : 'en-attente'
                        }`}>
                        {etudiantSelectionne.validationPedagogique?.statut || 'En attente'}
                      </span>
                    </span>
                  </div>
                  {etudiantSelectionne.validationPedagogique?.commentaire && (
                    <div className="info-row">
                      <span className="info-label">Commentaire pédagogique:</span>
                      <span className="info-value">{etudiantSelectionne.validationPedagogique.commentaire}</span>
                    </div>
                  )}
                  {etudiantSelectionne.validationPedagogique?.dateValidation && (
                    <div className="info-row">
                      <span className="info-label">Date de validation:</span>
                      <span className="info-value">
                        <Calendar size={16} className="info-icon" />
                        {formatDate(etudiantSelectionne.validationPedagogique.dateValidation)}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* Section Dates importantes */}
              {(etudiantSelectionne.dateInscription || etudiantSelectionne.dateEtReglement ||
                etudiantSelectionne.premiereAnneeInscription || etudiantSelectionne.lastSeen ||
                etudiantSelectionne.createdAt || etudiantSelectionne.updatedAt) && (
                  <div className="view-section">
                    <h4><Calendar size={20} className="section-icon" />Dates importantes</h4>
                    <div className="info-grid">
                      {etudiantSelectionne.dateInscription && (
                        <div className="info-row">
                          <span className="info-label">Date d'inscription:</span>
                          <span className="info-value">
                            <Calendar size={16} className="info-icon" />
                            {formatDate(etudiantSelectionne.dateInscription)}
                          </span>
                        </div>
                      )}
                      {etudiantSelectionne.premiereAnneeInscription && (
                        <div className="info-row">
                          <span className="info-label">Première année d'inscription:</span>
                          <span className="info-value">{etudiantSelectionne.premiereAnneeInscription}</span>
                        </div>
                      )}
                      {etudiantSelectionne.dateEtReglement && (
                        <div className="info-row">
                          <span className="info-label">Date et règlement:</span>
                          <span className="info-value">{etudiantSelectionne.dateEtReglement}</span>
                        </div>
                      )}
                      {etudiantSelectionne.lastSeen && (
                        <div className="info-row">
                          <span className="info-label">Dernière connexion:</span>
                          <span className="info-value">
                            <Clock size={16} className="info-icon" />
                            {formatDate(etudiantSelectionne.lastSeen)}
                          </span>
                        </div>
                      )}
                      {etudiantSelectionne.createdAt && (
                        <div className="info-row">
                          <span className="info-label">Créé le:</span>
                          <span className="info-value">
                            <Plus size={16} className="info-icon" />
                            {formatDate(etudiantSelectionne.createdAt)}
                          </span>
                        </div>
                      )}
                      {etudiantSelectionne.updatedAt && (
                        <div className="info-row">
                          <span className="info-label">Dernière modification:</span>
                          <span className="info-value">
                            <Edit size={16} className="info-icon" />
                            {formatDate(etudiantSelectionne.updatedAt)}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
            </div>

            <div className="modal-actions view-actions">
              <button onClick={() => handleEdit(etudiantSelectionne)} className="btn-modifier">
                <Edit size={16} className="info-icon" />
                Modifier
              </button>
              <button onClick={closeViewModal} className="btn-fermer">
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal d'export Excel */}
      {showExportModal && (
        <div className="modal-overlay" onClick={() => setShowExportModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Exporter vers Excel</h3>
              <button className="btn-fermer-modal" onClick={() => setShowExportModal(false)}>×</button>
            </div>

            <div className="export-content">
              <p>Sélectionnez l'année scolaire pour l'export des étudiants :</p>

              <div className="form-group">
                <label>Année Scolaire *</label>
                <select
                  value={exportAnneeScolaire}
                  onChange={(e) => setExportAnneeScolaire(e.target.value)}
                  className="select-filtre"
                  required
                >
                  <option value="">Sélectionner une année...</option>
                  {Array.from(new Set([
                    '2024/2025',
                    '2025/2026',
                    '2026/2027',
                    '2027/2028',
                    ...etudiants.map(e => e.anneeScolaire).filter(Boolean)
                  ])).sort().map(annee => (
                    <option key={annee} value={annee}>{annee}</option>
                  ))}
                </select>
              </div>

              {exportAnneeScolaire && (
                <div className="export-preview">
                  <p>
                    <strong>Aperçu :</strong> {etudiants.filter(e => e.anneeScolaire === exportAnneeScolaire).length} étudiant(s)
                    trouvé(s) pour l'année {exportAnneeScolaire}
                  </p>
                </div>
              )}
            </div>

            <div className="modal-actions">
              <button
                type="button"
                onClick={() => setShowExportModal(false)}
                className="btn-annuler"
                disabled={loadingExport}
              >
                Annuler
              </button>
              <button
                type="button"
                onClick={exportToExcel}
                className="btn-export"
                disabled={loadingExport || !exportAnneeScolaire}
              >
                {loadingExport ? '📥 Export en cours...' : '📊 Exporter'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PartnersCreateEtudiant;